import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import ReactModal from 'react-modal';
import styled$1 from 'react-emotion';
import classnames from 'classnames';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingPanel = function internalPaddingPanel(hasTitle) {
    return '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.TRIPLE + '; \n    padding-right: ' + spacing.SINGLE + '; \n    padding-top: ' + (hasTitle ? spacing.DOUBLE : spacing.TRIPLE) + ';\n';
};

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var layers = {
  datepicker1: 2147483647,
  globalTakeoverContent: 1053,
  globalTakeoverTransparency: 1052,
  globalTakeover: 1051,
  loader: 1051,
  modal1: 1050,
  modal2: 1040,
  localTakeover: 1020,
  popper: 110,
  webchat: 110,
  multiButtonModal: 104,
  wideModal: 104,
  accountLegacyPanelDropdown: 100,
  modal3: 100,
  paymentAccountSelector1: 16,
  paymentAccountSelector2: 15,
  checkboxToggleOffIcon: 10,
  comparisonTable: 10,
  accountSelectDropdown: 10,
  currencySelectDropdown: 10,
  header: 10,
  listPayment: 10,
  payeeFooterBar: 9,
  payeeList: 9,
  datepicker2: 5,
  searchAndSelect2: 5,
  searchAndSelect1: 3,
  datepicker: 2,
  datepicker3: 2,
  fauxBlockLink: 2,
  sortCardGroup: 2,
  submittedTransactionTable: 2,
  tileButtonOverlay: 2,
  root: 1,
  sub: -1
};

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var componentPaths = [
	{
		name: "ActionAnchor",
		path: "actions/anchors/ActionAnchor",
		styleguidePath: "Actions/Anchors/ActionAnchor",
		importPath: "web-ui-components/lib/actions/anchors"
	},
	{
		name: "ActionButton",
		path: "actions/buttons/ActionButton",
		styleguidePath: "Actions/Buttons/ActionButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "SwitchButton",
		path: "actions/buttons/SwitchButton",
		styleguidePath: "Actions/Buttons/SwitchButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "EmailLink",
		path: "actions/links/EmailLink",
		styleguidePath: "Actions/Links/EmailLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "PhoneLink",
		path: "actions/links/PhoneLink",
		styleguidePath: "Actions/Links/PhoneLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "WebsiteLink",
		path: "actions/links/WebsiteLink",
		styleguidePath: "Actions/Links/WebsiteLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "InputRadio",
		path: "actions/radios/InputRadio",
		styleguidePath: "Actions/Radios/InputRadio",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "InputRadioGroup",
		path: "actions/radios/InputRadioGroup",
		styleguidePath: "Actions/Radios/InputRadioGroup",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "TallRadioCard",
		path: "actions/radios/TallRadioCard",
		styleguidePath: "Actions/Radios/TallRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "WideRadioCard",
		path: "actions/radios/WideRadioCard",
		styleguidePath: "Actions/Radios/WideRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "NewWindowAction",
		path: "advisor/actions/NewWindowAction",
		styleguidePath: "Advisor/Actions/NewWindowAction",
		importPath: "web-ui-components/lib/advisor/actions"
	},
	{
		name: "CustomerAlert",
		path: "advisor/alerts/CustomerAlert",
		styleguidePath: "Advisor/Alerts/CustomerAlert",
		importPath: "web-ui-components/lib/advisor/alerts"
	},
	{
		name: "ClickableContentFrame",
		path: "advisor/layout/ClickableContentFrame",
		styleguidePath: "Advisor/Layout/ClickableContentFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "DashboardGrid",
		path: "advisor/layout/DashboardGrid",
		styleguidePath: "Advisor/Layout/DashboardGrid",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WideModal",
		path: "advisor/layout/WideModal",
		styleguidePath: "Advisor/Layout/WideModal",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WindowFrame",
		path: "advisor/layout/WindowFrame",
		styleguidePath: "Advisor/Layout/WindowFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "ProductRadioCard",
		path: "advisor/radios/ProductRadioCard",
		styleguidePath: "Advisor/Radios/ProductRadioCard",
		importPath: "web-ui-components/lib/advisor/radios"
	},
	{
		name: "AccountSelect",
		path: "advisor/selects/AccountSelect",
		styleguidePath: "Advisor/Selects/AccountSelect",
		importPath: "web-ui-components/lib/advisor/selects"
	},
	{
		name: "SessionTimeoutTakeover",
		path: "advisor/takeovers/SessionTimeoutTakeover",
		styleguidePath: "Advisor/Takeovers/SessionTimeoutTakeover",
		importPath: "web-ui-components/lib/advisor/takeovers"
	},
	{
		name: "Anchor",
		path: "atoms/buttons/Anchor",
		styleguidePath: "Atoms/Buttons/Anchor",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Button",
		path: "atoms/buttons/Button",
		styleguidePath: "Atoms/Buttons/Button",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "ButtonTitle",
		path: "atoms/buttons/ButtonTitle",
		styleguidePath: "Atoms/Buttons/ButtonTitle",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Calendar",
		path: "atoms/forms/Calendar",
		styleguidePath: "Atoms/Forms/Calendar",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Checkbox",
		path: "atoms/forms/Checkbox",
		styleguidePath: "Atoms/Forms/Checkbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "CheckboxToggle",
		path: "atoms/forms/CheckboxToggle",
		styleguidePath: "Atoms/Forms/CheckboxToggle",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Datepicker",
		path: "atoms/forms/Datepicker",
		styleguidePath: "Atoms/Forms/Datepicker",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "FieldDescription",
		path: "atoms/forms/FieldDescription",
		styleguidePath: "Atoms/Forms/FieldDescription",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Input",
		path: "atoms/forms/Input/Input",
		styleguidePath: "Atoms/Forms/Input/Input",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Prefix",
		path: "atoms/forms/Input/Prefix",
		styleguidePath: "Atoms/Forms/Input/Prefix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Suffix",
		path: "atoms/forms/Input/Suffix",
		styleguidePath: "Atoms/Forms/Input/Suffix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "TextPrompt",
		path: "atoms/forms/Input/TextPrompt",
		styleguidePath: "Atoms/Forms/Input/TextPrompt",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "InputClickable",
		path: "atoms/forms/InputClickable",
		styleguidePath: "Atoms/Forms/InputClickable",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "InputRange",
		path: "atoms/forms/InputRange",
		styleguidePath: "Atoms/Forms/InputRange",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "LabelTitle",
		path: "atoms/forms/Label/LabelTitle",
		styleguidePath: "Atoms/Forms/Label/LabelTitle",
		importPath: "web-ui-components/lib/atoms/forms/label"
	},
	{
		name: "Label",
		path: "atoms/forms/Label",
		styleguidePath: "Atoms/Forms/Label",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaCheckbox",
		path: "atoms/forms/MediaCheckbox",
		styleguidePath: "Atoms/Forms/MediaCheckbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaRadio",
		path: "atoms/forms/MediaRadio",
		styleguidePath: "Atoms/Forms/MediaRadio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MultiSelect",
		path: "atoms/forms/MultiSelect",
		styleguidePath: "Atoms/Forms/MultiSelect",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Radio",
		path: "atoms/forms/Radio",
		styleguidePath: "Atoms/Forms/Radio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "RadioCard",
		path: "atoms/forms/RadioCard",
		styleguidePath: "Atoms/Forms/RadioCard",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Select",
		path: "atoms/forms/Select",
		styleguidePath: "Atoms/Forms/Select",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Textarea",
		path: "atoms/forms/Textarea",
		styleguidePath: "Atoms/Forms/Textarea",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TextAreaCharacterCount",
		path: "atoms/forms/TextAreaCharacterCount",
		styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TimeEstimationIcon",
		path: "atoms/forms/TimeEstimationIcon",
		styleguidePath: "Atoms/Forms/TimeEstimationIcon",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "AnimatedIcon",
		path: "atoms/iconography/AnimatedIcon",
		styleguidePath: "Atoms/Iconography/AnimatedIcon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "DistinctiveGeneratedSymbol",
		path: "atoms/iconography/DistinctiveGeneratedSymbol",
		styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Icon",
		path: "atoms/iconography/Icon",
		styleguidePath: "Atoms/Iconography/Icon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Divider",
		path: "atoms/layout/Divider",
		styleguidePath: "Atoms/Layout/Divider",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "UploadPreviewContainer",
		path: "atoms/layout/UploadPreviewContainer",
		styleguidePath: "Atoms/Layout/UploadPreviewContainer",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "AndroidStoreLogo",
		path: "atoms/logo/AndroidStoreLogo",
		styleguidePath: "Atoms/Logo/AndroidStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "AppleStoreLogo",
		path: "atoms/logo/AppleStoreLogo",
		styleguidePath: "Atoms/Logo/AppleStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BankHeader",
		path: "atoms/logo/BankHeader",
		styleguidePath: "Atoms/Logo/BankHeader",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogo",
		path: "atoms/logo/BLogo",
		styleguidePath: "Atoms/Logo/BLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogoCircular",
		path: "atoms/logo/BLogoCircular",
		styleguidePath: "Atoms/Logo/BLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogo",
		path: "atoms/logo/CBLogo",
		styleguidePath: "Atoms/Logo/CBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogoCircular",
		path: "atoms/logo/CBLogoCircular",
		styleguidePath: "Atoms/Logo/CBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Header",
		path: "atoms/logo/Header",
		styleguidePath: "Atoms/Logo/Header",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "SwitchGuaranteeLogo",
		path: "atoms/logo/SwitchGuaranteeLogo",
		styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "VMSecondaryRedLogo",
		path: "atoms/logo/VMSecondaryRedLogo",
		styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogo",
		path: "atoms/logo/YBLogo",
		styleguidePath: "Atoms/Logo/YBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogoCircular",
		path: "atoms/logo/YBLogoCircular",
		styleguidePath: "Atoms/Logo/YBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Popover",
		path: "atoms/popovers/Popover",
		styleguidePath: "Atoms/Popovers/Popover",
		importPath: "web-ui-components/lib/atoms/popovers"
	},
	{
		name: "IdentityProcessingSignal",
		path: "atoms/signals/IdentityProcessingSignal",
		styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "UploadProcessingSignal",
		path: "atoms/signals/UploadProcessingSignal",
		styleguidePath: "Atoms/Signals/UploadProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "BadgeLabel",
		path: "atoms/text/BadgeLabel",
		styleguidePath: "Atoms/Text/BadgeLabel",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "BulletedList",
		path: "atoms/text/BulletedList",
		styleguidePath: "Atoms/Text/BulletedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Callout",
		path: "atoms/text/Callout",
		styleguidePath: "Atoms/Text/Callout",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "List",
		path: "atoms/text/List",
		styleguidePath: "Atoms/Text/List",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "NumberedList",
		path: "atoms/text/NumberedList",
		styleguidePath: "Atoms/Text/NumberedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "StatusBadge",
		path: "atoms/text/StatusBadge",
		styleguidePath: "Atoms/Text/StatusBadge",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextBody",
		path: "atoms/text/TextBody",
		styleguidePath: "Atoms/Text/TextBody",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextStyled",
		path: "atoms/text/TextStyled",
		styleguidePath: "Atoms/Text/TextStyled",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TheSmallPrint",
		path: "atoms/text/TheSmallPrint",
		styleguidePath: "Atoms/Text/TheSmallPrint",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Title",
		path: "atoms/text/Title",
		styleguidePath: "Atoms/Text/Title",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TransitionBlock",
		path: "atoms/transitions/TransitionBlock",
		styleguidePath: "Atoms/Transitions/TransitionBlock",
		importPath: "web-ui-components/lib/atoms/transitions"
	},
	{
		name: "EmailInput",
		path: "communication/email/text-inputs/EmailInput",
		styleguidePath: "Communication/Email/Text-inputs/EmailInput",
		importPath: "web-ui-components/lib/communication/email/text-inputs"
	},
	{
		name: "Mail",
		path: "communication/messaging/Mail",
		styleguidePath: "Communication/Messaging/Mail",
		importPath: "web-ui-components/lib/communication/messaging"
	},
	{
		name: "Webchat",
		path: "communication/support/Webchat",
		styleguidePath: "Communication/Support/Webchat",
		importPath: "web-ui-components/lib/communication/support"
	},
	{
		name: "CheckboxContainer",
		path: "data/capture/checkboxes/CheckboxContainer",
		styleguidePath: "Data/Capture/Checkboxes/CheckboxContainer",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "GenericCheckbox",
		path: "data/capture/checkboxes/GenericCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "StandaloneCheckbox",
		path: "data/capture/checkboxes/StandaloneCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "AccountNumberInput",
		path: "data/capture/inputs/AccountNumberInput",
		styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DateOfBirthInput",
		path: "data/capture/inputs/DateOfBirthInput",
		styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "FileUploadInput",
		path: "data/capture/inputs/FileUploadInput",
		styleguidePath: "Data/Capture/Inputs/FileUploadInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericAlphaNumericInput",
		path: "data/capture/inputs/GenericAlphaNumericInput",
		styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericIntegerInput",
		path: "data/capture/inputs/GenericIntegerInput",
		styleguidePath: "Data/Capture/Inputs/GenericIntegerInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericTextInput",
		path: "data/capture/inputs/GenericTextInput",
		styleguidePath: "Data/Capture/Inputs/GenericTextInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "LandlineNumberInput",
		path: "data/capture/inputs/LandlineNumberInput",
		styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MoneyInput",
		path: "data/capture/inputs/MoneyInput",
		styleguidePath: "Data/Capture/Inputs/MoneyInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MonthAndYearDateInput",
		path: "data/capture/inputs/MonthAndYearDateInput",
		styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "PasscodeNumberInput",
		path: "data/capture/inputs/PasscodeNumberInput",
		styleguidePath: "Data/Capture/Inputs/PasscodeNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SliderInput",
		path: "data/capture/inputs/SliderInput",
		styleguidePath: "Data/Capture/Inputs/SliderInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SortcodeInput",
		path: "data/capture/inputs/SortcodeInput",
		styleguidePath: "Data/Capture/Inputs/SortcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyMobileNumberInput",
		path: "data/capture/inputs/UKOnlyMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyPostcodeInput",
		path: "data/capture/inputs/UKOnlyPostcodeInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "WorldwideMobileNumberInput",
		path: "data/capture/inputs/WorldwideMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "YearsAndMonthsCountInput",
		path: "data/capture/inputs/YearsAndMonthsCountInput",
		styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DayOfMonthPicker",
		path: "data/capture/pickers/DayOfMonthPicker",
		styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
		importPath: "web-ui-components/lib/data/capture/pickers"
	},
	{
		name: "FileProgressTakeover",
		path: "data/capture/progress/FileProgressTakeover",
		styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
		importPath: "web-ui-components/lib/data/capture/progress"
	},
	{
		name: "GenericRadio",
		path: "data/capture/radios/GenericRadio",
		styleguidePath: "Data/Capture/Radios/GenericRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "IconifiedRadio",
		path: "data/capture/radios/IconifiedRadio",
		styleguidePath: "Data/Capture/Radios/IconifiedRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "RadioContainer",
		path: "data/capture/radios/RadioContainer",
		styleguidePath: "Data/Capture/Radios/RadioContainer",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "AccountCardSelect",
		path: "data/capture/selects/AccountCardSelect",
		styleguidePath: "Data/Capture/Selects/AccountCardSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericSelect",
		path: "data/capture/selects/GenericSelect",
		styleguidePath: "Data/Capture/Selects/GenericSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericTextArea",
		path: "data/capture/text-areas/GenericTextArea",
		styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
		importPath: "web-ui-components/lib/data/capture/text-areas"
	},
	{
		name: "InternationalMoneyValue",
		path: "data/display/values/InternationalMoneyValue",
		styleguidePath: "Data/Display/Values/InternationalMoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "MoneyValue",
		path: "data/display/values/MoneyValue",
		styleguidePath: "Data/Display/Values/MoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "GenericPaginator",
		path: "data/filter-and-search/paginators/GenericPaginator",
		styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
		importPath: "web-ui-components/lib/data/filter-and-search/paginators"
	},
	{
		name: "SearchSelectInput",
		path: "data/filter-and-search/text-inputs/SearchSelectInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchSelectInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "SearchTextInput",
		path: "data/filter-and-search/text-inputs/SearchTextInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "CompactDescriptionList",
		path: "data/lists/description-lists/CompactDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/CompactDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "GenericDescriptionList",
		path: "data/lists/description-lists/GenericDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "NoResultsTile",
		path: "data/results/tiles/NoResultsTile",
		styleguidePath: "Data/Results/Tiles/NoResultsTile",
		importPath: "web-ui-components/lib/data/results/tiles"
	},
	{
		name: "DocumentLink",
		path: "documents/navigation/links/DocumentLink",
		styleguidePath: "Documents/Navigation/Links/DocumentLink",
		importPath: "web-ui-components/lib/documents/navigation/links"
	},
	{
		name: "DocumentLinkPlate",
		path: "documents/navigation/plates/DocumentLinkPlate",
		styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
		importPath: "web-ui-components/lib/documents/navigation/plates"
	},
	{
		name: "PrintButton",
		path: "documents/printing/buttons/PrintButton",
		styleguidePath: "Documents/Printing/Buttons/PrintButton",
		importPath: "web-ui-components/lib/documents/printing/buttons"
	},
	{
		name: "DocumentStatusBandCard",
		path: "documents/statuses/cards/DocumentStatusBandCard",
		styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
		importPath: "web-ui-components/lib/documents/statuses/cards"
	},
	{
		name: "FileInput",
		path: "documents/upload/FileInput",
		styleguidePath: "Documents/Upload/FileInput",
		importPath: "web-ui-components/lib/documents/upload"
	},
	{
		name: "AccountCheckboxCard",
		path: "finance/accounts/cards/AccountCheckboxCard",
		styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLegacyUpdateCard",
		path: "finance/accounts/cards/AccountLegacyUpdateCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLinkCard",
		path: "finance/accounts/cards/AccountLinkCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountPoolCard",
		path: "finance/accounts/cards/AccountPoolCard",
		styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountSelectCard",
		path: "finance/accounts/cards/AccountSelectCard",
		styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountStaticCard",
		path: "finance/accounts/cards/AccountStaticCard",
		styleguidePath: "Finance/Accounts/Cards/AccountStaticCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountAuthorisationPanel",
		path: "finance/accounts/panels/AccountAuthorisationPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountBalancesSelectPanel",
		path: "finance/accounts/panels/AccountBalancesSelectPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountLegacyPanel",
		path: "finance/accounts/panels/AccountLegacyPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPaymentStatusPanel",
		path: "finance/accounts/panels/AccountPaymentStatusPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPaymentStatusPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPoolTablePanel",
		path: "finance/accounts/panels/AccountPoolTablePanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountRadioCard",
		path: "finance/accounts/radios/AccountRadioCard",
		styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
		importPath: "web-ui-components/lib/finance/accounts/radios"
	},
	{
		name: "AccountPaymentReviewTable",
		path: "finance/accounts/tables/AccountPaymentReviewTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentSubmittedTable",
		path: "finance/accounts/tables/AccountPaymentSubmittedTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentTable",
		path: "finance/accounts/tables/AccountPaymentTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountSummaryTile",
		path: "finance/accounts/tiles/AccountSummaryTile",
		styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
		importPath: "web-ui-components/lib/finance/accounts/tiles"
	},
	{
		name: "CurrencySelect",
		path: "finance/currency/selects/CurrencySelect",
		styleguidePath: "Finance/Currency/Selects/CurrencySelect",
		importPath: "web-ui-components/lib/finance/currency/selects"
	},
	{
		name: "BlockField",
		path: "global/layout/BlockField",
		styleguidePath: "Global/Layout/BlockField",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "BlockFieldColumn",
		path: "global/layout/BlockFieldColumn",
		styleguidePath: "Global/Layout/BlockFieldColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "CenterImageContainer",
		path: "global/layout/CenterImageContainer",
		styleguidePath: "Global/Layout/CenterImageContainer",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Column",
		path: "global/layout/Column",
		styleguidePath: "Global/Layout/Column",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Container",
		path: "global/layout/Container",
		styleguidePath: "Global/Layout/Container",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexColumn",
		path: "global/layout/FlexColumn",
		styleguidePath: "Global/Layout/FlexColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexRow",
		path: "global/layout/FlexRow",
		styleguidePath: "Global/Layout/FlexRow",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Frame",
		path: "global/layout/Frame",
		styleguidePath: "Global/Layout/Frame",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "InternalSlot",
		path: "global/layout/InternalSlot",
		styleguidePath: "Global/Layout/InternalSlot",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "LeftAndRightAlignment",
		path: "global/layout/LeftAndRightAlignment",
		styleguidePath: "Global/Layout/LeftAndRightAlignment",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "PageLayout",
		path: "global/layout/PageLayout",
		styleguidePath: "Global/Layout/PageLayout",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "HeaderSection",
		path: "global/layout/Pages/HeaderSection",
		styleguidePath: "Global/Layout/Pages/HeaderSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ServicingSection",
		path: "global/layout/Pages/ServicingSection",
		styleguidePath: "Global/Layout/Pages/ServicingSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "WorkflowSection",
		path: "global/layout/Pages/WorkflowSection",
		styleguidePath: "Global/Layout/Pages/WorkflowSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ResponsiveLayoutPair",
		path: "global/layout/ResponsiveLayoutPair",
		styleguidePath: "Global/Layout/ResponsiveLayoutPair",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Row",
		path: "global/layout/Row",
		styleguidePath: "Global/Layout/Row",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "ContentContainer",
		path: "layout/containers/ContentContainer",
		styleguidePath: "Layout/Containers/ContentContainer",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "Main",
		path: "layout/containers/Main",
		styleguidePath: "Layout/Containers/Main",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "GenericAccordion",
		path: "layout/content/accordions/GenericAccordion",
		styleguidePath: "Layout/Content/Accordions/GenericAccordion",
		importPath: "web-ui-components/lib/layout/content/accordions"
	},
	{
		name: "StatusBanner",
		path: "layout/content/banners/StatusBanner",
		styleguidePath: "Layout/Content/Banners/StatusBanner",
		importPath: "web-ui-components/lib/layout/content/banners"
	},
	{
		name: "GenericDivider",
		path: "layout/content/breaks/GenericDivider",
		styleguidePath: "Layout/Content/Breaks/GenericDivider",
		importPath: "web-ui-components/lib/layout/content/breaks"
	},
	{
		name: "GenericModal",
		path: "layout/content/modals/GenericModal",
		styleguidePath: "Layout/Content/Modals/GenericModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "InformationModal",
		path: "layout/content/modals/InformationModal",
		styleguidePath: "Layout/Content/Modals/InformationModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "MultiButtonModal",
		path: "layout/content/modals/MultiButtonModal",
		styleguidePath: "Layout/Content/Modals/MultiButtonModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "BrandedPanel",
		path: "layout/content/panels/BrandedPanel",
		styleguidePath: "Layout/Content/Panels/BrandedPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ConditionalPanel",
		path: "layout/content/panels/ConditionalPanel",
		styleguidePath: "Layout/Content/Panels/ConditionalPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ContentRevealPanel",
		path: "layout/content/panels/ContentRevealPanel",
		styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "GenericPanel",
		path: "layout/content/panels/GenericPanel",
		styleguidePath: "Layout/Content/Panels/GenericPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "InformationRevealPanel",
		path: "layout/content/panels/InformationRevealPanel",
		styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellPanel",
		path: "layout/content/panels/ShellPanel",
		styleguidePath: "Layout/Content/Panels/ShellPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellSidebarPanel",
		path: "layout/content/panels/ShellSidebarPanel",
		styleguidePath: "Layout/Content/Panels/ShellSidebarPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SimplePanel",
		path: "layout/content/panels/SimplePanel",
		styleguidePath: "Layout/Content/Panels/SimplePanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "StatusPanel",
		path: "layout/content/panels/StatusPanel",
		styleguidePath: "Layout/Content/Panels/StatusPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SubformRevealPanel",
		path: "layout/content/panels/SubformRevealPanel",
		styleguidePath: "Layout/Content/Panels/SubformRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ToggleButtonPanel",
		path: "layout/content/panels/ToggleButtonPanel",
		styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ProcessingScreenTakeover",
		path: "layout/content/takeovers/ProcessingScreenTakeover",
		styleguidePath: "Layout/Content/Takeovers/ProcessingScreenTakeover",
		importPath: "web-ui-components/lib/layout/content/takeovers"
	},
	{
		name: "AttentionTile",
		path: "layout/content/tiles/AttentionTile",
		styleguidePath: "Layout/Content/Tiles/AttentionTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GuidanceTile",
		path: "layout/content/tiles/GuidanceTile",
		styleguidePath: "Layout/Content/Tiles/GuidanceTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "OutcomeTile",
		path: "layout/content/tiles/OutcomeTile",
		styleguidePath: "Layout/Content/Tiles/OutcomeTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "RecapTile",
		path: "layout/content/tiles/RecapTile",
		styleguidePath: "Layout/Content/Tiles/RecapTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "StandoutTile",
		path: "layout/content/tiles/StandoutTile",
		styleguidePath: "Layout/Content/Tiles/StandoutTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "ValidationMessageTile",
		path: "layout/content/tiles/ValidationMessageTile",
		styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GridListToggle",
		path: "layout/content/views/GridListToggle",
		styleguidePath: "Layout/Content/Views/GridListToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GridViewToggle",
		path: "layout/content/views/GridViewToggle",
		styleguidePath: "Layout/Content/Views/GridViewToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GenericFieldWrapper",
		path: "layout/fieldWrappers/GenericFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GenericFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "GroupFieldWrapper",
		path: "layout/fieldWrappers/GroupFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GroupFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "MainFixedFooter",
		path: "layout/footers/MainFixedFooter",
		styleguidePath: "Layout/Footers/MainFixedFooter",
		importPath: "web-ui-components/lib/layout/footers"
	},
	{
		name: "Grid",
		path: "layout/grids/Grid",
		styleguidePath: "Layout/Grids/Grid",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "Inline",
		path: "layout/grids/Inline",
		styleguidePath: "Layout/Grids/Inline",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "ContainedHeader",
		path: "layout/headers/ContainedHeader",
		styleguidePath: "Layout/Headers/ContainedHeader",
		importPath: "web-ui-components/lib/layout/headers"
	},
	{
		name: "FixedFooter",
		path: "layout/sections/footers/FixedFooter",
		styleguidePath: "Layout/Sections/Footers/FixedFooter",
		importPath: "web-ui-components/lib/layout/sections/footers"
	},
	{
		name: "ApplicationFormShell",
		path: "layout/shells/ApplicationFormShell",
		styleguidePath: "Layout/Shells/ApplicationFormShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "DataManagementShell",
		path: "layout/shells/DataManagementShell",
		styleguidePath: "Layout/Shells/DataManagementShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "ShellInnerSpacer",
		path: "layout/shells/ShellInnerSpacer",
		styleguidePath: "Layout/Shells/ShellInnerSpacer",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "VerticalReviewTable",
		path: "layout/tables/VerticalReviewTable",
		styleguidePath: "Layout/Tables/VerticalReviewTable",
		importPath: "web-ui-components/lib/layout/tables"
	},
	{
		name: "NonUKAddressFieldset",
		path: "location/addresses/fieldsets/NonUKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressFieldset",
		path: "location/addresses/fieldsets/UKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressCaptureModule",
		path: "location/addresses/modules/UKAddressCaptureModule",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "UKAddressCaptureModule2",
		path: "location/addresses/modules/UKAddressCaptureModule2",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "BaseSelect",
		path: "location/places/selects/BaseSelect",
		styleguidePath: "Location/Places/Selects/BaseSelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "CountrySelect",
		path: "location/places/selects/CountrySelect",
		styleguidePath: "Location/Places/Selects/CountrySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "UKCitySelect",
		path: "location/places/selects/UKCitySelect",
		styleguidePath: "Location/Places/Selects/UKCitySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "AccordionItem",
		path: "molecules/accordions/Accordion/AccordionItem",
		styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
		importPath: "web-ui-components/lib/molecules/accordions/accordion"
	},
	{
		name: "Accordion",
		path: "molecules/accordions/Accordion",
		styleguidePath: "Molecules/Accordions/Accordion",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "AccordionTable",
		path: "molecules/accordions/AccordionTable",
		styleguidePath: "Molecules/Accordions/AccordionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ContentReveal",
		path: "molecules/accordions/ContentReveal",
		styleguidePath: "Molecules/Accordions/ContentReveal",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionPanel",
		path: "molecules/accordions/ExpansionPanel",
		styleguidePath: "Molecules/Accordions/ExpansionPanel",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionTable",
		path: "molecules/accordions/ExpansionTable",
		styleguidePath: "Molecules/Accordions/ExpansionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ButtonGroup",
		path: "molecules/buttons/ButtonGroup",
		styleguidePath: "Molecules/Buttons/ButtonGroup",
		importPath: "web-ui-components/lib/molecules/buttons"
	},
	{
		name: "SortingCardGroup",
		path: "molecules/card-groups/SortingCardGroup",
		styleguidePath: "Molecules/Card-groups/SortingCardGroup",
		importPath: "web-ui-components/lib/molecules/card-groups"
	},
	{
		name: "AccountCard",
		path: "molecules/cards/AccountCard",
		styleguidePath: "Molecules/Cards/AccountCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "AccountSummaryLinkCard",
		path: "molecules/cards/AccountSummaryLinkCard",
		styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "DateCard",
		path: "molecules/cards/DateCard",
		styleguidePath: "Molecules/Cards/DateCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "PromoCard",
		path: "molecules/cards/PromoCard",
		styleguidePath: "Molecules/Cards/PromoCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "StackingCard",
		path: "molecules/cards/StackingCard",
		styleguidePath: "Molecules/Cards/StackingCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "Autocomplete",
		path: "molecules/forms/Autocomplete",
		styleguidePath: "Molecules/Forms/Autocomplete",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ConfirmationCheckbox",
		path: "molecules/forms/ConfirmationCheckbox",
		styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "DaySelector",
		path: "molecules/forms/DaySelector",
		styleguidePath: "Molecules/Forms/DaySelector",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "FieldBody",
		path: "molecules/forms/Field/FieldBody",
		styleguidePath: "Molecules/Forms/Field/FieldBody",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FieldHeader",
		path: "molecules/forms/Field/FieldHeader",
		styleguidePath: "Molecules/Forms/Field/FieldHeader",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FormField",
		path: "molecules/forms/Field/FormField",
		styleguidePath: "Molecules/Forms/Field/FormField",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "Field",
		path: "molecules/forms/Field",
		styleguidePath: "Molecules/Forms/Field",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "PasswordReveal",
		path: "molecules/forms/PasswordReveal",
		styleguidePath: "Molecules/Forms/PasswordReveal",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "RadioCardGroup",
		path: "molecules/forms/RadioCardGroup",
		styleguidePath: "Molecules/Forms/RadioCardGroup",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "Search",
		path: "molecules/forms/Search",
		styleguidePath: "Molecules/Forms/Search",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SearchForm",
		path: "molecules/forms/SearchForm",
		styleguidePath: "Molecules/Forms/SearchForm",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControl",
		path: "molecules/forms/SegmentedControl",
		styleguidePath: "Molecules/Forms/SegmentedControl",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControlItem",
		path: "molecules/forms/SegmentedControl/SegmentedControlItem",
		styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
		importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
	},
	{
		name: "SegmentedSlider",
		path: "molecules/forms/SegmentedSlider",
		styleguidePath: "Molecules/Forms/SegmentedSlider",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ValidationMessage",
		path: "molecules/forms/ValidationMessage",
		styleguidePath: "Molecules/Forms/ValidationMessage",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "IconTextDynamic",
		path: "molecules/icon-text-dynamic/IconTextDynamic",
		styleguidePath: "Molecules/IconTextDynamic/IconTextDynamic",
		importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
	},
	{
		name: "IconText",
		path: "molecules/icon-text/IconText",
		styleguidePath: "Molecules/IconText/IconText",
		importPath: "web-ui-components/lib/molecules/icon-text"
	},
	{
		name: "BackAnchor",
		path: "molecules/navigation/BackAnchor",
		styleguidePath: "Molecules/Navigation/BackAnchor",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "BackButton",
		path: "molecules/navigation/BackButton",
		styleguidePath: "Molecules/Navigation/BackButton",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Utility",
		path: "molecules/navigation/Utility",
		styleguidePath: "Molecules/Navigation/Utility",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Alert",
		path: "molecules/nbas/Alert",
		styleguidePath: "Molecules/NBAS/Alert",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "Promo",
		path: "molecules/nbas/Promo",
		styleguidePath: "Molecules/NBAS/Promo",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "ContrastingFormPanel",
		path: "molecules/panels/ContrastingFormPanel",
		styleguidePath: "Molecules/Panels/ContrastingFormPanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "DocumentAction",
		path: "molecules/panels/DocumentAction",
		styleguidePath: "Molecules/Panels/DocumentAction",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "IconifiedBulletPoint",
		path: "molecules/panels/IconifiedBulletPoint",
		styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "Panel",
		path: "molecules/panels/Panel",
		styleguidePath: "Molecules/Panels/Panel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PanelBody",
		path: "molecules/panels/Panel/PanelBody",
		styleguidePath: "Molecules/Panels/Panel/PanelBody",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelFooter",
		path: "molecules/panels/Panel/PanelFooter",
		styleguidePath: "Molecules/Panels/Panel/PanelFooter",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelHeader",
		path: "molecules/panels/Panel/PanelHeader",
		styleguidePath: "Molecules/Panels/Panel/PanelHeader",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelSector",
		path: "molecules/panels/Panel/PanelSector",
		styleguidePath: "Molecules/Panels/Panel/PanelSector",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "SettingLink",
		path: "molecules/panels/SettingLink",
		styleguidePath: "Molecules/Panels/SettingLink",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "SubordinatePanel",
		path: "molecules/panels/SubordinatePanel",
		styleguidePath: "Molecules/Panels/SubordinatePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "TogglePanel",
		path: "molecules/panels/TogglePanel",
		styleguidePath: "Molecules/Panels/TogglePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PayeeCard",
		path: "molecules/payee-cards/PayeeCard",
		styleguidePath: "Molecules/PayeeCard/PayeeCard",
		importPath: "web-ui-components/lib/molecules/payee-cards"
	},
	{
		name: "PaymentReview",
		path: "molecules/payments/PaymentReview",
		styleguidePath: "Molecules/Payments/PaymentReview",
		importPath: "web-ui-components/lib/molecules/payments"
	},
	{
		name: "ProgressIndicator",
		path: "molecules/progress/ProgressIndicator",
		styleguidePath: "Molecules/Progress/ProgressIndicator",
		importPath: "web-ui-components/lib/molecules/progress"
	},
	{
		name: "ProgressIndicatorItem",
		path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
		styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
		importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
	},
	{
		name: "ComparisonTable",
		path: "molecules/tables/ComparisonTable",
		styleguidePath: "Molecules/Tables/ComparisonTable",
		importPath: "web-ui-components/lib/molecules/tables"
	},
	{
		name: "DataTable",
		path: "molecules/tables/Table/DataTable",
		styleguidePath: "Molecules/Tables/Table/DataTable",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "Table",
		path: "molecules/tables/Table/Table",
		styleguidePath: "Molecules/Tables/Table/Table",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBody",
		path: "molecules/tables/Table/TableBody",
		styleguidePath: "Molecules/Tables/Table/TableBody",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBodyData",
		path: "molecules/tables/Table/TableBodyData",
		styleguidePath: "Molecules/Tables/Table/TableBodyData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHead",
		path: "molecules/tables/Table/TableHead",
		styleguidePath: "Molecules/Tables/Table/TableHead",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHeadData",
		path: "molecules/tables/Table/TableHeadData",
		styleguidePath: "Molecules/Tables/Table/TableHeadData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableRow",
		path: "molecules/tables/Table/TableRow",
		styleguidePath: "Molecules/Tables/Table/TableRow",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "SectionHeading",
		path: "molecules/text/SectionHeading",
		styleguidePath: "Molecules/Text/SectionHeading",
		importPath: "web-ui-components/lib/molecules/text"
	},
	{
		name: "ConfirmationTile",
		path: "molecules/tile/ConfirmationTile",
		styleguidePath: "Molecules/Tile/ConfirmationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "ExclamationTile",
		path: "molecules/tile/ExclamationTile",
		styleguidePath: "Molecules/Tile/ExclamationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "HighlightTile",
		path: "molecules/tile/HighlightTile",
		styleguidePath: "Molecules/Tile/HighlightTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "IconTile",
		path: "molecules/tile/IconTile",
		styleguidePath: "Molecules/Tile/IconTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "NumberedTile",
		path: "molecules/tile/NumberedTile",
		styleguidePath: "Molecules/Tile/NumberedTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "Tile",
		path: "molecules/tile/Tile",
		styleguidePath: "Molecules/Tile/Tile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "TileSector",
		path: "molecules/tile/Tile/TileSector",
		styleguidePath: "Molecules/Tile/Tile/TileSector",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "TileSegment",
		path: "molecules/tile/Tile/TileSegment",
		styleguidePath: "Molecules/Tile/Tile/TileSegment",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "ToggleOption",
		path: "molecules/toggle/ToggleOption",
		styleguidePath: "Molecules/Toggle/ToggleOption",
		importPath: "web-ui-components/lib/molecules/toggle"
	},
	{
		name: "PromoAnchor",
		path: "navigation/anchors/PromoAnchor",
		styleguidePath: "Navigation/Anchors/PromoAnchor",
		importPath: "web-ui-components/lib/navigation/anchors"
	},
	{
		name: "NavigationButton",
		path: "navigation/buttons/NavigationButton",
		styleguidePath: "Navigation/Buttons/NavigationButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "NavigationButtonGroup",
		path: "navigation/buttons/NavigationButtonGroup",
		styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "PromoButton",
		path: "navigation/buttons/PromoButton",
		styleguidePath: "Navigation/Buttons/PromoButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "ProgressStepper",
		path: "navigation/indicators/ProgressStepper",
		styleguidePath: "Navigation/Indicators/ProgressStepper",
		importPath: "web-ui-components/lib/navigation/indicators"
	},
	{
		name: "VerticalMenu",
		path: "navigation/menus/VerticalMenu",
		styleguidePath: "Navigation/Menus/VerticalMenu",
		importPath: "web-ui-components/lib/navigation/menus"
	},
	{
		name: "MainNavLink",
		path: "navigation/nav-links/MainNavLink",
		styleguidePath: "Navigation/Nav-links/MainNavLink",
		importPath: "web-ui-components/lib/navigation/nav-links"
	},
	{
		name: "Paginator",
		path: "navigation/pagination/Paginator",
		styleguidePath: "Navigation/Pagination/Paginator",
		importPath: "web-ui-components/lib/navigation/pagination"
	},
	{
		name: "PaginatorNextButton",
		path: "navigation/pagination/Paginator/PaginatorNextButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPageButton",
		path: "navigation/pagination/Paginator/PaginatorPageButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPreviousButton",
		path: "navigation/pagination/Paginator/PaginatorPreviousButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "MainSiteNav",
		path: "navigation/site-navs/MainSiteNav",
		styleguidePath: "Navigation/Site-navs/MainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "MobileMainSiteNav",
		path: "navigation/site-navs/MobileMainSiteNav",
		styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNav",
		path: "navigation/site-navs/UtilityNav",
		styleguidePath: "Navigation/Site-navs/UtilityNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNavButton",
		path: "navigation/site-navs/UtilityNavButton",
		styleguidePath: "Navigation/Site-navs/UtilityNavButton",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "TabCard",
		path: "navigation/tab-cards/TabCard",
		styleguidePath: "Navigation/Tab-cards/TabCard",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardBlock",
		path: "navigation/tab-cards/TabCardBlock",
		styleguidePath: "Navigation/Tab-cards/TabCardBlock",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardSmall",
		path: "navigation/tab-cards/TabCardSmall",
		styleguidePath: "Navigation/Tab-cards/TabCardSmall",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabGroup",
		path: "navigation/tab-group/TabGroup",
		styleguidePath: "Navigation/Tab-group/TabGroup",
		importPath: "web-ui-components/lib/navigation/tab-group"
	},
	{
		name: "TransferTakeover",
		path: "navigation/takeovers/TransferTakeover",
		styleguidePath: "Navigation/Takeovers/TransferTakeover",
		importPath: "web-ui-components/lib/navigation/takeovers"
	},
	{
		name: "Card",
		path: "organisms/cards/Card",
		styleguidePath: "Organisms/Cards/Card",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "DistinctiveLinkCard",
		path: "organisms/cards/DistinctiveLinkCard",
		styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "FilterAction",
		path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
	},
	{
		name: "FilterActionGroup",
		path: "organisms/filters/Filter/FilterActionGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSector",
		path: "organisms/filters/Filter/FilterSector",
		styleguidePath: "Organisms/Filters/Filter/FilterSector",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSegment",
		path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
	},
	{
		name: "FilterSegmentGroup",
		path: "organisms/filters/Filter/FilterSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSubSegment",
		path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
	},
	{
		name: "FilterSubSegmentGroup",
		path: "organisms/filters/Filter/FilterSubSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "Filter",
		path: "organisms/filters/Filter",
		styleguidePath: "Organisms/Filters/Filter",
		importPath: "web-ui-components/lib/organisms/filters"
	},
	{
		name: "GlobalHeader",
		path: "organisms/global/GlobalHeader",
		styleguidePath: "Organisms/Global/GlobalHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "HeroHeader",
		path: "organisms/global/HeroHeader",
		styleguidePath: "Organisms/Global/HeroHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "CentredModal",
		path: "organisms/modals/CentredModal",
		styleguidePath: "Organisms/Modals/CentredModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ConfirmationModal",
		path: "organisms/modals/ConfirmationModal",
		styleguidePath: "Organisms/Modals/ConfirmationModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "Loader",
		path: "organisms/modals/Loader",
		styleguidePath: "Organisms/Modals/Loader",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ModalBody",
		path: "organisms/modals/Modal/ModalBody",
		styleguidePath: "Organisms/Modals/Modal/ModalBody",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalContainer",
		path: "organisms/modals/Modal/ModalContainer",
		styleguidePath: "Organisms/Modals/Modal/ModalContainer",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalHeader",
		path: "organisms/modals/Modal/ModalHeader",
		styleguidePath: "Organisms/Modals/Modal/ModalHeader",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "Modal",
		path: "organisms/modals/Modal",
		styleguidePath: "Organisms/Modals/Modal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "UnfinishedWorkModal",
		path: "organisms/modals/UnfinishedWorkModal",
		styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "DisableTakeover",
		path: "organisms/takeovers/DisableTakeover",
		styleguidePath: "Organisms/Takeovers/DisableTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "LoadingLocalTakeover",
		path: "organisms/takeovers/LoadingLocalTakeover",
		styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "Timeline",
		path: "organisms/timelines/Timeline",
		styleguidePath: "Organisms/Timeline/Timeline",
		importPath: "web-ui-components/lib/organisms/timelines"
	},
	{
		name: "ProductSelector",
		path: "products/selection/ProductSelector",
		styleguidePath: "Products/Selection/ProductSelector",
		importPath: "web-ui-components/lib/products/selection"
	},
	{
		name: "EmailCreationInput",
		path: "security/authentication/inputs/EmailCreationInput",
		styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "PasswordCreationInput",
		path: "security/authentication/inputs/PasswordCreationInput",
		styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "CallButton",
		path: "telephony/Buttons/CallButton",
		styleguidePath: "Telephony/Buttons/CallButton",
		importPath: "web-ui-components/lib/telephony/buttons"
	},
	{
		name: "CallStatus",
		path: "telephony/Statuses/CallStatus",
		styleguidePath: "Telephony/Statuses/CallStatus",
		importPath: "web-ui-components/lib/telephony/statuses"
	},
	{
		name: "LogoDisplay",
		path: "transactions/logo/LogoDisplay",
		styleguidePath: "Transactions/Logo/LogoDisplay",
		importPath: "web-ui-components/lib/transactions/logo"
	},
	{
		name: "Footer",
		path: "typography/ancillary/Footer",
		styleguidePath: "Typography/Ancillary/Footer",
		importPath: "web-ui-components/lib/typography/ancillary"
	},
	{
		name: "LargeBody",
		path: "typography/body/LargeBody",
		styleguidePath: "Typography/Body/LargeBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SecondaryBody",
		path: "typography/body/SecondaryBody",
		styleguidePath: "Typography/Body/SecondaryBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SignificantBody",
		path: "typography/body/SignificantBody",
		styleguidePath: "Typography/Body/SignificantBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SmallestBody",
		path: "typography/body/SmallestBody",
		styleguidePath: "Typography/Body/SmallestBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "StandardBody",
		path: "typography/body/StandardBody",
		styleguidePath: "Typography/Body/StandardBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SubBody",
		path: "typography/body/SubBody",
		styleguidePath: "Typography/Body/SubBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "VisuallyHiddenBody",
		path: "typography/body/VisuallyHiddenBody",
		styleguidePath: "Typography/Body/VisuallyHiddenBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "PageHeading",
		path: "typography/headings/PageHeading",
		styleguidePath: "Typography/Headings/PageHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SectionHeading",
		path: "typography/headings/SectionHeading",
		styleguidePath: "Typography/Headings/SectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubHeading",
		path: "typography/headings/SubHeading",
		styleguidePath: "Typography/Headings/SubHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubsectionHeading",
		path: "typography/headings/SubsectionHeading",
		styleguidePath: "Typography/Headings/SubsectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "LargeHero",
		path: "typography/heros/LargeHero",
		styleguidePath: "Typography/Heros/LargeHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "StandardHero",
		path: "typography/heros/StandardHero",
		styleguidePath: "Typography/Heros/StandardHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "IndicativeHighlight",
		path: "typography/highlights/IndicativeHighlight",
		styleguidePath: "Typography/Highlights/IndicativeHighlight",
		importPath: "web-ui-components/lib/typography/highlights"
	},
	{
		name: "StateIndicator",
		path: "typography/indicators/StateIndicator",
		styleguidePath: "Typography/Indicators/StateIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "StepIndicator",
		path: "typography/indicators/StepIndicator",
		styleguidePath: "Typography/Indicators/StepIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "FieldLabel",
		path: "typography/labels/FieldLabel",
		styleguidePath: "Typography/Labels/FieldLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "ProminentLabel",
		path: "typography/labels/ProminentLabel",
		styleguidePath: "Typography/Labels/ProminentLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "StandardLabel",
		path: "typography/labels/StandardLabel",
		styleguidePath: "Typography/Labels/StandardLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "SubLabel",
		path: "typography/labels/SubLabel",
		styleguidePath: "Typography/Labels/SubLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "BulletList",
		path: "typography/lists/BulletList",
		styleguidePath: "Typography/Lists/BulletList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NegativeList",
		path: "typography/lists/NegativeList",
		styleguidePath: "Typography/Lists/NegativeList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NumberList",
		path: "typography/lists/NumberList",
		styleguidePath: "Typography/Lists/NumberList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "PositiveList",
		path: "typography/lists/PositiveList",
		styleguidePath: "Typography/Lists/PositiveList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "TickList",
		path: "typography/lists/TickList",
		styleguidePath: "Typography/Lists/TickList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "Identifier",
		path: "typography/modifiers/Identifier",
		styleguidePath: "Typography/Modifiers/Identifier",
		importPath: "web-ui-components/lib/typography/modifiers"
	},
	{
		name: "AbbreviatedTag",
		path: "typography/tags/AbbreviatedTag",
		styleguidePath: "Typography/Tags/AbbreviatedTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "StatusTag",
		path: "typography/tags/StatusTag",
		styleguidePath: "Typography/Tags/StatusTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "ValueTag",
		path: "typography/tags/ValueTag",
		styleguidePath: "Typography/Tags/ValueTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "MostProminentValue",
		path: "typography/values/MostProminentValue",
		styleguidePath: "Typography/Values/MostProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "ProminentValue",
		path: "typography/values/ProminentValue",
		styleguidePath: "Typography/Values/ProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "StandardValue",
		path: "typography/values/StandardValue",
		styleguidePath: "Typography/Values/StandardValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "VeryProminentValue",
		path: "typography/values/VeryProminentValue",
		styleguidePath: "Typography/Values/VeryProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "UserStatusBandCard",
		path: "users/business-users/cards/UserStatusBandCard",
		styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
		importPath: "web-ui-components/lib/users/business-users/cards"
	}
];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids",
			variant: "Centered"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ShellPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GridListToggle",
			path: "Layout/Content/Views"
		}
	}],
	deprecationVersion: "28.3.0",
	deprecationDate: "January 21 2022"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}, {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions/GenericAccordion"
		}, {
			name: "InformationRevealPanel",
			path: "Layout/Content/Panels"
		}]
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SliderInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "28.4.0",
	deprecationDate: "June 21 2022"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericPanel",
			path: "Layout/Content/Panels",
			variant: "Interaction"
		}
	}],
	deprecationVersion: "33.3.0",
	deprecationDate: "April 03 2024"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;

var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';

var DeprecationWarnings = {
	logComponent: function logComponent(componentName) {
		var deprecatedComponentObj = componentPaths.find(function (_ref) {
			var name = _ref.name;
			return name === componentName;
		});
		var oldPath = deprecatedComponentObj.styleguidePath;
		deprecatedComponentObj = deprecated.find(function (_ref2) {
			var name = _ref2.name;
			return name.includes(componentName);
		});

		var depreactionReplacements = deprecatedComponentObj.deprecations[0].replacements;
		var hasMultipleReplacements = Array.isArray(depreactionReplacements);
		var newPath = hasMultipleReplacements ? depreactionReplacements.map(function (replacement) {
			return replacement.path + '/' + replacement.name;
		}) : depreactionReplacements.path + '/' + depreactionReplacements.name;

		deprecatedDictComponents[componentName] = { oldPath: oldPath, newPath: newPath };
	},
	logIcon: function logIcon(componentName, deprecatedIcon) {
		var deprecatedComponentObj = componentPaths.find(function (_ref3) {
			var name = _ref3.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		var oldPath = path + ': ' + deprecatedIcon;
		var newPath = path + ': ' + deprecatedIcon;
		var iconName = componentName + ': ' + deprecatedIcon;

		deprecatedDictComponents[iconName] = { oldPath: oldPath, newPath: newPath };
	},
	logProp: function logProp(packageJson, description) {
		var _packageJson$main$spl = packageJson.main.split('.'),
		    _packageJson$main$spl2 = slicedToArray(_packageJson$main$spl, 1),
		    componentName = _packageJson$main$spl2[0];

		var deprecatedComponentObj = componentPaths.find(function (_ref4) {
			var name = _ref4.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		deprecatedDictProps[componentName] = { path: path, description: description };
	},
	report: function report() {
		setTimeout(function () {
			var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;
			if (numberOfDeprecations > 0) {
				console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);

				console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
				Object.entries(deprecatedDictComponents).forEach(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    componentName = _ref6[0],
					    info = _ref6[1];

					var oldPath = info.oldPath,
					    newPath = info.newPath;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', oldPath);

					var hasMultipleReplacements = Array.isArray(newPath);
					if (hasMultipleReplacements) {
						newPath.map(function (replacement, index) {
							return console.warn('Replacement ' + (index + 1) + ':', replacement);
						});
					} else {
						console.warn('Replacement:', newPath);
					}
					console.groupEnd();
				});
				console.groupEnd();

				console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
				Object.entries(deprecatedDictProps).forEach(function (_ref7) {
					var _ref8 = slicedToArray(_ref7, 2),
					    componentName = _ref8[0],
					    info = _ref8[1];

					var path = info.path,
					    description = info.description;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', path);
					console.warn('Reason:', description);
					console.groupEnd();
				});
				console.groupEnd();

				console.groupEnd();
				deprecatedDictComponents = {};
				deprecatedDictProps = {};
			}
		}, timeoutDelay);
	},
	warn: function warn(message) {
		return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
	}
};

Object.freeze(DeprecationWarnings);

var _templateObject$5 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\t', ';\n\toverflow: hidden;\n\tposition: relative;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\t', ';\n\toverflow: hidden;\n\tposition: relative;\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tmax-height: 90vh;\n\toverflow-y: auto;\n\tpadding: ', ' ', ' ', ' ', ';\n\t', ';\n'], ['\n\tcolor: ', ';\n\tmax-height: 90vh;\n\toverflow-y: auto;\n\tpadding: ', ' ', ' ', ' ', ';\n\t', ';\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n\tmargin: auto;\n\tmax-width: ', ';\n'], ['\n\tmargin: auto;\n\tmax-width: ', ';\n']);

var StyledModalContent = styled('div')(_templateObject$5, colours.component.background, function (props) {
	return props.theme.borderRadiusLargest;
}, function (props) {
	return internalPaddingPanel(props.hasTitle);
});

var StyledModalBackdrop = styled('div')(_templateObject2$4, colours.component.modalBackdrop, layers.sub);

var StyledDialogContainer = styled('div')(_templateObject3$3, function (props) {
	return props.theme.colours.bodyText;
}, spacing.QUADRUPLE, spacing.DOUBLE, spacing.DOUBLE, spacing.DOUBLE, function (props) {
	return props.hasCentredContent && 'text-align: center;';
});

var StyledDialog = styled('div')(_templateObject4$2, function (props) {
	return props.isWide ? '1024px' : '36.25rem';
});

var ModalContainer = function ModalContainer(_ref) {
	var children = _ref.children,
	    hasCentredContent = _ref.hasCentredContent,
	    isWide = _ref.isWide,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledDialogContainer,
		{ hasCentredContent: hasCentredContent, 'data-test-id': dataTestId },
		React.createElement(
			StyledDialog,
			{ isWide: isWide },
			React.createElement(
				StyledModalContent,
				null,
				children
			)
		),
		React.createElement(StyledModalBackdrop, null)
	);
};

ModalContainer.propTypes = {
	/** Child node */
	children: PropTypes.node,
	/** Set to true to centre the modal. */
	hasCentredContent: PropTypes.bool,
	/** Set to true to make the modal wider. */
	isWide: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string
};

ModalContainer.defaultProps = {
	hasCentredContent: false,
	isWide: false
};

var ModalFooter = function ModalFooter(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		null,
		children
	);
};

ModalFooter.propTypes = {
	children: PropTypes.node.isRequired
};

var main = "SubHeading.js";
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n'], ['\n\tcolor: ', ';\n\t', ';\n\tfont-family: ', ';\n\tmargin: 0;\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']);

var StyledSubHeading = styled('h2')(_templateObject$6, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? useFontSize.of.arran() : useFontSize.of.islay();
}, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledWrapper$1 = styled('div')(_templateObject2$5, function (props) {
	return props.isFlush && 'margin-bottom: 0;';
}, function (props) {
	return props.theme.colours.heading;
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
}, function (props) {
	return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
	return props.theme.isCompact ? '14px' : '28px';
});

/**
 * Uses `<h2>` tag internally.
 * @example ./Design.md
 */
var SubHeading = function SubHeading(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    isFlush = _ref.isFlush,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson, isFlush: isFlush, layout: 'typography' },
		React.createElement(
			StyledWrapper$1,
			{ isFlush: isFlush },
			icon,
			React.createElement(
				StyledSubHeading,
				{ id: id, 'data-test-id': dataTestId },
				children
			)
		)
	);
};

SubHeading.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional Left aligned icon with SubHeading. */
	icon: PropTypes.node,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

SubHeading.defaultProps = {
	isFlush: false,
	'data-test-id': 'sub-heading'
};

var INTERNET_BANKING_CSS_OVERRIDE = '!important';

var _templateObject$7 = taggedTemplateLiteral(['\n\talign-items: flex-start;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\th2 {\n\t\tmargin-bottom: 0 ', ';\n\t\tmargin-right: ', ';\n\t}\n'], ['\n\talign-items: flex-start;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\th2 {\n\t\tmargin-bottom: 0 ', ';\n\t\tmargin-right: ', ';\n\t}\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tmargin-right: ', ' ', ';\n\tpadding: ', ' ', ';\n\ttext-decoration: underline;\n'], ['\n\tbackground: none;\n\tborder: none;\n\tborder-radius: ', ';\n\tcolor: ', ';\n\tmargin-right: ', ' ', ';\n\tpadding: ', ' ', ';\n\ttext-decoration: underline;\n']);

var StyledHeader = styled('div')(_templateObject$7, INTERNET_BANKING_CSS_OVERRIDE, spacing.SINGLE);

var StyledButton$1 = styled('button')(_templateObject2$6, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.colours.primary;
}, spacing.DOUBLE, INTERNET_BANKING_CSS_OVERRIDE, spacing.QUARTER, INTERNET_BANKING_CSS_OVERRIDE);

var ModalHeader = function ModalHeader(_ref) {
	var titleText = _ref.titleText,
	    onClick = _ref.onClick,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		StyledHeader,
		null,
		React.createElement(
			SubHeading,
			{ id: id },
			titleText
		),
		React.createElement(
			StyledButton$1,
			{ onClick: onClick, type: 'button', 'data-test-id': dataTestId },
			'Close'
		)
	);
};

ModalHeader.propTypes = {
	/** Modal headers title string */
	titleText: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func,
	/** Data attribute targeting inner html close button for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** A unique ID used for identification within the DOM.. */
	id: PropTypes.string
};

ModalHeader.defaultProps = {
	hasCentredContent: false,
	isWide: false
};

var _templateObject$8 = taggedTemplateLiteral(['\n\toverflow: hidden;\n'], ['\n\toverflow: hidden;\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\tposition: fixed;\n\ttop: ', ';\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tdisplay: none;\n\toverflow-x: hidden;\n\toverflow-y: scroll;\n\toutline: 0;\n\t&.show {\n\t\tdisplay: block;\n\t\topacity: 1;\n\t}\n'], ['\n\tposition: fixed;\n\ttop: ', ';\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tdisplay: none;\n\toverflow-x: hidden;\n\toverflow-y: scroll;\n\toutline: 0;\n\t&.show {\n\t\tdisplay: block;\n\t\topacity: 1;\n\t}\n']);

var modalOpenBodyStyles = css(_templateObject$8);

var modalStyles = function modalStyles(isCentred) {
	return css(_templateObject2$7, isCentred ? '25vh' : 0, layers.modal1);
};

var removeDefaultClasses = {
	afterOpen: '',
	base: '',
	beforeClose: ''
};

var BaseModal = function BaseModal(_ref) {
	var children = _ref.children,
	    footerContent = _ref.footerContent,
	    hasCentredContent = _ref.hasCentredContent,
	    isCentred = _ref.isCentred,
	    isOpen = _ref.isOpen,
	    isWide = _ref.isWide,
	    onAfterOpen = _ref.onAfterOpen,
	    onClose = _ref.onClose,
	    titleText = _ref.titleText,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		ReactModal,
		{
			role: 'alertdialog',
			aria: { labelledby: id + '-header', describedby: id + '-header' },
			appElement: document.body,
			contentLabel: 'Modal',
			closeTimeoutMS: 300,
			isOpen: isOpen,
			onRequestClose: onClose,
			onAfterOpen: onAfterOpen,
			className: _extends({}, removeDefaultClasses, { base: 'react-modal__dialog' }),
			bodyOpenClassName: modalOpenBodyStyles,
			overlayClassName: {
				base: modalStyles(isCentred),
				afterOpen: 'show',
				beforeClose: 'hide'
			},
			style: {
				overlay: {
					display: 'block'
				},
				content: {
					outline: 'none'
				}
			}
		},
		React.createElement(
			ModalContainer,
			{ hasCentredContent: hasCentredContent, isWide: isWide, 'data-test-id': dataTestId + '-container' },
			React.createElement(ModalHeader, { titleText: titleText, onClick: onClose, id: id + '-header', 'data-test-id': dataTestId + '-button' }),
			React.createElement(
				'div',
				{ id: id + '-content' },
				children
			),
			footerContent && React.createElement(
				ModalFooter,
				null,
				footerContent
			)
		)
	);
};

BaseModal.propTypes = {
	/** Body content. */
	children: PropTypes.node.isRequired,
	/** Footer content. */
	footerContent: PropTypes.node,
	/** Set to true to centre the modal. */
	hasCentredContent: PropTypes.bool,
	/** Set to true to make the modal wider. */
	isWide: PropTypes.bool,
	/** Set to true to show the modal. */
	isOpen: PropTypes.bool.isRequired,
	/** Set to true to centre the modal. */
	isCentred: PropTypes.bool,
	/** Callback function invoked when close button is clicked. */
	onClose: PropTypes.func,
	onAfterOpen: PropTypes.func,
	/** Titletext */
	titleText: PropTypes.string.isRequired,
	/** Partial Data attribute targeting modal for automation test purposes - appended by -button and -container. */
	'data-test-id': PropTypes.string,
	/** A unique ID used for identification within the DOM.. */
	id: PropTypes.string
};

BaseModal.defaultProps = {
	hasCentredContent: false,
	isCentred: false,
	isWide: false,
	'data-test-id': 'base-modal',
	id: 'base-modal'
};

var main$1 = "CentredModal.js";
var deprecations = [{
	replacements: {
		name: "ConfirmationModal",
		path: "Organisms/Modals"
	}
}];
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations
};

var CentredModal = function CentredModal(_ref) {
	var buttonNode = _ref.buttonNode,
	    children = _ref.children,
	    isOpen = _ref.isOpen,
	    onClose = _ref.onClose,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$1, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true },
		React.createElement(
			BaseModal,
			{
				hasCentredContent: true,
				isOpen: isOpen,
				onClose: onClose,
				titleText: titleText || title,
				footerContent: buttonNode,
				'data-test-id': dataTestId,
				id: id
			},
			React.createElement(
				'div',
				null,
				children
			)
		)
	);
};

CentredModal.propTypes = {
	/** Buttons contained in modal footer. */
	buttonNode: PropTypes.node.isRequired,
	/** Body content. */
	children: PropTypes.node.isRequired,
	/** Set to true to show the modal. */
	isOpen: PropTypes.bool,
	/** Callback function invoked when close button is clicked. */
	onClose: PropTypes.func.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Title text. */
	titleText: PropTypes.string.isRequired,
	/** Partial Data attribute targeting modal for automation test purposes - appended by -button and -container. */
	'data-test-id': PropTypes.string,
	/** A unique ID used for identification within the DOM.. */
	id: PropTypes.string
};

CentredModal.defaultProps = {
	isOpen: false,
	'data-test-id': 'centered-modal',
	id: 'centered-modal'
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var LoadingOutlineSmallIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var ButtonTitle = function ButtonTitle(_ref) {
	var children = _ref.children;
	return React.createElement(
		'span',
		{ className: 'c-a-button__title' },
		children
	);
};

ButtonTitle.propTypes = {
	children: PropTypes.node
};

var main$2 = "Button.js";
var deprecations$1 = [{
	replacements: [{
		name: "ActionButton",
		path: "Actions/Buttons"
	}, {
		name: "NavigationButton",
		path: "Navigation/Buttons"
	}]
}];
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$1
};

var wrapTextNodes = function wrapTextNodes(children) {
	return React.Children.map(children, function (child) {
		return typeof child === 'string' ? React.createElement(
			ButtonTitle,
			null,
			child
		) : child;
	});
};

var Button = function (_Component) {
	inherits(Button, _Component);

	function Button(props) {
		classCallCheck(this, Button);

		var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

		_this.buttonRef = null;
		return _this;
	}

	createClass(Button, [{
		key: 'focus',
		value: function focus() {
			if (this.buttonRef) {
				this.buttonRef.focus();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _classnames,
			    _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    isLoading = _props.isLoading,
			    loadingText = _props.loadingText,
			    width = _props.width,
			    display = _props.display,
			    size = _props.size,
			    className = _props.className,
			    disabled = _props.disabled,
			    rest = objectWithoutProperties(_props, ['children', 'isLoading', 'loadingText', 'width', 'display', 'size', 'className', 'disabled']);

			var allClassNames = classnames(className, 'c-a-button', (_classnames = {}, defineProperty(_classnames, 'c-a-button--width-' + width, width), defineProperty(_classnames, 'c-a-button--size-' + size, size), defineProperty(_classnames, 'c-a-button--' + display, display), defineProperty(_classnames, 'c-a-button--is-spinning', isLoading), _classnames));

			var buttonProps = _extends({
				disabled: isLoading || disabled
			}, isLoading && { 'aria-live': 'polite' }, isLoading && { 'aria-busy': 'true' }, rest);

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'inline-block' },
				React.createElement(
					'button',
					_extends({
						className: allClassNames,
						ref: function ref(component) {
							_this2.buttonRef = component;
						}
					}, buttonProps),
					wrapTextNodes(children),
					isLoading && React.createElement(
						'div',
						{ className: 'c-a-button__loading-spinner' },
						React.createElement(
							'span',
							{ className: 'c-a-button__loading-spinner-icon' },
							React.createElement(LoadingOutlineSmallIcon, null)
						),
						React.createElement(
							'span',
							{ className: 'c-a-button__loading-spinner-label' },
							loadingText
						)
					)
				)
			);
		}
	}]);
	return Button;
}(Component);

Button.propTypes = {
	/** Child content as single node or array of nodes. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	/** Sets a custom class name. */
	className: PropTypes.string,
	/** Controls the button disabled state. */
	disabled: PropTypes.bool,
	/** Specify a display type. */
	display: PropTypes.oneOf(['primary', 'secondary']),
	/** Controls the loading state of the button. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** Callback function triggered on click. */
	onClick: PropTypes.func,
	/** Sets the size. */
	size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
	/** Sets the width. */
	width: PropTypes.oneOf(['flush', 'narrow', 'wide', 'full'])
};

Button.defaultProps = {
	isLoading: false,
	loadingText: 'Loading',
	size: 'md',
	disabled: false
};

var main$3 = "ButtonGroup.js";
var deprecations$2 = [{
	replacements: [{
		name: "NavigationButtonGroup",
		path: "Navigation/Buttons"
	}, {
		name: "Inline",
		path: "Layout/Grids"
	}]
}];
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$2
};

var alignmentOptions = ['left', 'center', 'right'];

/** The ButtonGroup is used to contain and align one or more anchor or button component(s).  */
var ButtonGroup = function ButtonGroup(_ref) {
	var alignment = _ref.alignment,
	    children = _ref.children;

	var buttonGroupClasses = classnames('c-m-button-group', {
		'u-flex-justify-content-center': alignment === 'center',
		'u-flex-justify-content-flex-end': alignment === 'right'
	});

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, hasCustomMargins: true },
		React.createElement(
			'div',
			{ className: buttonGroupClasses },
			children
		)
	);
};

ButtonGroup.propTypes = {
	/** Sets the options for different alignment variations on the children. */
	alignment: PropTypes.oneOf(alignmentOptions),
	/** An array of elements, rendered as children within the button group. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
};

ButtonGroup.defaultProps = {
	alignment: 'left'
};

var main$4 = "ConfirmationModal.js";
var deprecations$3 = [{
	replacements: {
		name: "GenericModal",
		path: "Layout/Content/Modals"
	}
}];
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$3
};

var _templateObject$9 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\t', ';\n'], ['\n\tmargin-bottom: ', ';\n\t', ';\n']);

var StyledButtonWrapper = styled$1('div')(_templateObject$9, spacing.SINGLE, function (props) {
	return props.theme.name !== 'vm' && 'margin-left: ' + spacing.SINGLE;
});

var ConfirmationModal = function ConfirmationModal(_ref) {
	var children = _ref.children,
	    confirmButtonIsDisabled = _ref.confirmButtonIsDisabled,
	    confirmButtonText = _ref.confirmButtonText,
	    dismissButtonIsDisabled = _ref.dismissButtonIsDisabled,
	    dismissButtonText = _ref.dismissButtonText,
	    isCentred = _ref.isCentred,
	    isOpen = _ref.isOpen,
	    onClose = _ref.onClose,
	    onConfirm = _ref.onConfirm,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;

	var buttonGroup = React.createElement(
		StyledButtonWrapper,
		null,
		React.createElement(
			ButtonGroup,
			null,
			React.createElement(
				Button,
				{ display: 'secondary', disabled: dismissButtonIsDisabled, size: 'sm', onClick: onClose },
				dismissButtonText
			),
			React.createElement(
				Button,
				{ display: 'primary', disabled: confirmButtonIsDisabled, size: 'sm', onClick: onConfirm },
				confirmButtonText
			)
		)
	);

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$4, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4, hasCustomMargins: true },
		React.createElement(
			BaseModal,
			{
				isCentred: isCentred,
				isOpen: isOpen,
				onClose: onClose,
				titleText: titleText || title,
				footerContent: buttonGroup,
				'data-test-id': dataTestId,
				id: id
			},
			React.createElement(
				'div',
				null,
				children
			)
		)
	);
};

ConfirmationModal.propTypes = {
	/** Body content. */
	children: PropTypes.node.isRequired,
	/** Confirm button disabled status. */
	confirmButtonIsDisabled: PropTypes.bool,
	/** Confirm button text. */
	confirmButtonText: PropTypes.string,
	/** Dismiss button disabled status. */
	dismissButtonIsDisabled: PropTypes.bool,
	/** Dismiss button text. */
	dismissButtonText: PropTypes.string,
	/** Set to true to centre the modal. */
	isCentred: PropTypes.bool,
	/** Set to true to show the modal. */
	isOpen: PropTypes.bool,
	/** Callback function invoked when close button is clicked. */
	onClose: PropTypes.func.isRequired,
	/** Callback function invoked on confirm. */
	onConfirm: PropTypes.func.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Titletext */
	titleText: PropTypes.string.isRequired,
	/** Partial Data attribute targeting modal for automation test purposes - appended by -button and -container. */
	'data-test-id': PropTypes.string,
	/** A unique ID used for identification within the DOM.. */
	id: PropTypes.string
};

ConfirmationModal.defaultProps = {
	confirmButtonIsDisabled: false,
	confirmButtonText: 'OK',
	dismissButtonIsDisabled: false,
	dismissButtonText: 'Cancel',
	isCentred: false,
	isOpen: false,
	'data-test-id': 'confirmation-modal',
	id: 'confirmation-modal'
};

var main$5 = "Loader.js";
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$a = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n'], ['\n\tbackground-color: ', ';\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\topacity: 0.7;\n\tright: 0;\n\ttop: 0;\n\tz-index: ', ';\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\topacity: 1;\n\tclip: auto;\n\theight: auto;\n\twidth: auto;\n\toverflow: visible;\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tcolor: ', ';\n\tuser-select: none;\n\ttransition: opacity 0.35s ease-in-out;\n\t', ';\n'], ['\n\topacity: 1;\n\tclip: auto;\n\theight: auto;\n\twidth: auto;\n\toverflow: visible;\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: ', ';\n\tcolor: ', ';\n\tuser-select: none;\n\ttransition: opacity 0.35s ease-in-out;\n\t', ';\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 340px;\n\tjustify-content: center;\n\tmax-height: 50vh;\n\tmax-width: 90vw;\n\tmin-height: 248px;\n\tpadding: 24px;\n\twidth: 640px;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder-radius: ', ';\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 340px;\n\tjustify-content: center;\n\tmax-height: 50vh;\n\tmax-width: 90vw;\n\tmin-height: 248px;\n\tpadding: 24px;\n\twidth: 640px;\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding-left: ', ';\n\tpadding-right: ', ';\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\t', ';\n'], ['\n\tmargin-bottom: ', ';\n\t', ';\n']),
    _templateObject6$2 = taggedTemplateLiteral(['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\t', ';\n'], ['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\t', ';\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\tp {\n\t\tmargin-bottom: ', ';\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n'], ['\n\tpadding-bottom: ', ';\n\ttext-align: center;\n\tp {\n\t\tmargin-bottom: ', ';\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n']);

injectGlobal('\n\t.has-global-takeover {\n\t\toverflow: hidden;\n\t}\n');

var StyledBackdrop = styled('div')(_templateObject$a, colours.component.modalBackdrop, layers.sub);

var StyledTakeover = styled('div')(_templateObject2$8, layers.loader, function (props) {
	return props.theme.components.loader.colours.color;
}, function (props) {
	return !props.isOpen && '\n\t\tdisplay: none!important\n\t';
});

var StyledContent = styled('div')(_templateObject3$4, function (props) {
	return props.theme.components.loader.colours.background;
}, function (props) {
	return props.theme.borderRadiusLargest;
});

var StyledContentWrapper = styled('div')(_templateObject4$3, spacing.DOUBLE, spacing.DOUBLE);

var StyledMedia = styled('div')(_templateObject5$2, spacing.SINGLE, function (props) {
	return props.theme.name !== 'vm' && 'svg {\n\t\t\tanimation: ' + animations.rotate + ' 1.25s linear infinite;\n\t\t\tfill: ' + colours.generalPalette.white + ';\n\t\t\theight: ' + spacing.SEXTUPLE + ';\n\t\t\tpointer-events: none;\n\t\t\twidth: ' + spacing.SEXTUPLE + ';\n\t\t}';
});

var StyledTitleWrapper = styled('div')(_templateObject6$2, spacing.DOUBLE, useFontSize.of.mull());

var StyledBodyWrapper = styled('div')(_templateObject7$1, spacing.DOUBLE, spacing.SINGLE);

var toggleBodyClass = function toggleBodyClass(flag) {
	if (flag) {
		document.body.classList.add('has-global-takeover');
	} else {
		document.body.classList.remove('has-global-takeover');
	}
};

var Loader = function (_Component) {
	inherits(Loader, _Component);

	function Loader() {
		classCallCheck(this, Loader);
		return possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	}

	createClass(Loader, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			toggleBodyClass(this.props.isOpen);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var isOpen = this.props.isOpen;

			if (!isOpen && nextProps.isOpen) {
				toggleBodyClass(true);
			} else if (isOpen && !nextProps.isOpen) {
				toggleBodyClass(false);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			toggleBodyClass(false);
		}
	}, {
		key: 'render',
		value: function render() {
			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    title = _props.title,
			    titleText = _props.titleText,
			    titleID = _props.titleID,
			    body = _props.body,
			    children = _props.children,
			    isOpen = _props.isOpen,
			    theme = _props.theme;

			var bodyFont = theme.components.loader.fonts.body;
			var loadingSpinner = theme.components.loader.root.loadingSpinner;

			var titleFont = theme.components.loader.fonts.title;

			if (title !== undefined) {
				DeprecationWarnings.logProp(packageJson$5, 'title prop deprecated in favour of titleText prop.');
			}

			return React.createElement(
				StyledTakeover,
				{ 'aria-labelledby': titleID, 'aria-live': 'polite', isOpen: isOpen, tabIndex: '-1', role: 'dialog' },
				React.createElement(
					StyledContentWrapper,
					null,
					React.createElement(
						StyledContent,
						null,
						React.createElement(
							StyledMedia,
							null,
							loadingSpinner
						),
						React.createElement(
							StyledTitleWrapper,
							{ id: titleID },
							titleFont(titleText || title)
						),
						body && React.createElement(
							StyledBodyWrapper,
							null,
							bodyFont(body)
						),
						children
					)
				),
				React.createElement(StyledBackdrop, null)
			);
		}
	}]);
	return Loader;
}(Component);

Loader.propTypes = {
	/** Boolean controlling whether loader is shown or not. */
	isOpen: PropTypes.bool.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Loader title text. */
	titleText: PropTypes.string,
	/** ID attribute for title, used to add accessibility aria attributes for screen readers. */
	titleID: PropTypes.string,
	/** Loader body text. */
	body: PropTypes.string,
	/** Child content as element, node or string. */
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string])
};

Loader.defaultProps = {
	title: 'Please wait'
};

var WrappedLoader = withTheme(Loader);

var ModalBody = function ModalBody(_ref) {
	var children = _ref.children,
	    title = _ref.title,
	    scrollable = _ref.scrollable;
	return React.createElement(
		'div',
		{ className: 'c-o-modal__body modal-body', style: { overflowY: scrollable ? 'auto' : 'inherit' } },
		title && React.createElement(
			'h3',
			{ className: 'c-o-modal__title modal-title' },
			title
		),
		children
	);
};

ModalBody.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
	scrollable: PropTypes.bool
};

ModalBody.defaultProps = {
	scrollable: false
};

var _templateObject$b = taggedTemplateLiteral(['\n\tz-index: -1 !important;\n'], ['\n\tz-index: -1 !important;\n']);

var StyledModalBackdrop$1 = styled('div')(_templateObject$b);

var ModalContainer$1 = function ModalContainer(_ref) {
	var children = _ref.children,
	    handleClick = _ref.handleClick;
	return React.createElement(
		'div',
		{ role: 'presentation', className: 'c-o-modal__inner', onClick: handleClick, onKeyUp: handleClick },
		React.createElement(
			'div',
			{ className: 'c-o-modal__dialog modal-dialog', role: 'document' },
			React.createElement(
				'div',
				{
					role: 'presentation',
					className: 'c-o-modal__content modal-content',
					onClick: function onClick(e) {
						return e.stopPropagation();
					},
					onKeyUp: function onKeyUp(e) {
						return e.stopPropagation();
					}
				},
				children
			)
		),
		React.createElement(StyledModalBackdrop$1, { className: 'modal-backdrop fade show' })
	);
};

ModalContainer$1.propTypes = {
	children: PropTypes.node,
	handleClick: PropTypes.func
};

var ModalFooter$1 = function ModalFooter(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-o-modal__footer modal-footer' },
		children
	);
};

ModalFooter$1.propTypes = {
	children: PropTypes.node
};

var ModalHeader$1 = function ModalHeader(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-o-modal__header modal-header' },
		children
	);
};

ModalHeader$1.propTypes = {
	children: PropTypes.node
};

var main$6 = "Modal.js";
var deprecations$4 = [{
	replacements: {
		name: "ConfirmationModal",
		path: "Organisms/Modals"
	}
}];
var packageJson$6 = {
	main: main$6,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$4
};

injectGlobal('\n\t.react-modal__overlay {\n\t\tdisplay: block !important;\n\t}\n\t.react-modal__dialog {\n\t\toutline: none !important;\t\n\t}\n');

var removeDefaultClasses$1 = {
	base: '',
	afterOpen: '',
	beforeClose: ''
};

var sanitiseSize = function sanitiseSize(size) {
	return {
		sm: 'small',
		md: 'medium',
		lg: 'large'
	}[size] || 'medium';
};

var Modal = function Modal(_ref) {
	var isOpen = _ref.isOpen,
	    onAfterOpen = _ref.onAfterOpen,
	    onRequestClose = _ref.onRequestClose,
	    shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
	    title = _ref.title,
	    size = _ref.size,
	    header = _ref.header,
	    children = _ref.children,
	    footer = _ref.footer,
	    customMainClass = _ref.customMainClass,
	    scrollable = _ref.scrollable,
	    returnFocusAfterClose = _ref.returnFocusAfterClose;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$6, hasCustomMargins: true },
		React.createElement(
			ReactModal,
			{
				appElement: document.body,
				bodyOpenClassName: customMainClass ? customMainClass + ' modal-open' : 'modal-open',
				className: _extends({}, removeDefaultClasses$1, { base: 'react-modal__dialog' }),
				closeTimeoutMS: 300,
				contentLabel: 'Modal',
				isOpen: isOpen,
				onAfterOpen: onAfterOpen,
				onRequestClose: onRequestClose,
				overlayClassName: {
					base: 'c-o-modal react-modal__overlay fade modal c-o-modal--' + sanitiseSize(size),
					afterOpen: 'show',
					beforeClose: 'hide'
				},
				shouldReturnFocusAfterClose: returnFocusAfterClose
			},
			React.createElement(
				ModalContainer$1,
				{
					animationClass: onAfterOpen(),
					handleClick: function handleClick() {
						return shouldCloseOnOverlayClick ? onRequestClose() : function () {};
					}
				},
				header && React.createElement(
					ModalHeader$1,
					null,
					header
				),
				React.createElement(
					ModalBody,
					{ scrollable: scrollable, title: title },
					children
				),
				footer && React.createElement(
					ModalFooter$1,
					null,
					footer
				)
			)
		)
	);
};

Modal.propTypes = {
	children: PropTypes.node.isRequired,
	footer: PropTypes.node,
	header: PropTypes.node.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onAfterOpen: PropTypes.func,
	onRequestClose: PropTypes.func,
	shouldCloseOnOverlayClick: PropTypes.bool,
	size: PropTypes.string,
	title: PropTypes.string,
	customMainClass: PropTypes.string,
	scrollable: PropTypes.bool,
	returnFocusAfterClose: PropTypes.bool
};

Modal.defaultProps = {
	size: 'md',
	onAfterOpen: function onAfterOpen() {},
	returnFocusAfterClose: false
};

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.977 36.744c0 5.985-.069 11.97.016 17.955.131 9.132-3.816 16.446-10.205 22.695-8.719 8.527-19.322 14.043-30.618 18.404-.686.262-1.656.274-2.336.008-12.2-4.75-23.614-10.738-32.59-20.479-5.442-5.905-8.304-12.757-8.239-20.83.1-12.48.056-24.963-.005-37.444-.01-1.966.636-3.007 2.6-3.683C21.12 9.063 33.59 4.606 46.113.3c1.13-.39 2.633-.404 3.76-.016 12.593 4.33 25.134 8.806 37.718 13.159 1.773.613 2.422 1.588 2.408 3.374-.057 6.643-.023 13.285-.023 19.927zM76.748 71.928C71.541 61.31 60.624 54 48 54c-12.616 0-23.527 7.3-28.738 17.908C26.34 79.354 35.4 84.814 47.995 89.815c11.743-4.626 20.537-9.805 27.597-16.71.4-.391.785-.783 1.156-1.177zM48 48c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M89.977 36.744c0 5.985-.069 11.97.016 17.955.131 9.132-3.816 16.446-10.205 22.695-8.719 8.527-19.322 14.043-30.618 18.404-.686.262-1.656.274-2.336.008-12.2-4.75-23.614-10.738-32.59-20.479-5.442-5.905-8.304-12.757-8.239-20.83.1-12.48.056-24.963-.005-37.444-.01-1.966.636-3.007 2.6-3.683C21.12 9.063 33.59 4.606 46.113.3c1.13-.39 2.633-.404 3.76-.016 12.593 4.33 25.134 8.806 37.718 13.159 1.773.613 2.422 1.588 2.408 3.374-.057 6.643-.023 13.285-.023 19.927zM76.748 71.928C71.541 61.31 60.624 54 48 54c-12.616 0-23.527 7.3-28.738 17.908C26.34 79.354 35.4 84.814 47.995 89.815c11.743-4.626 20.537-9.805 27.597-16.71.4-.391.785-.783 1.156-1.177zM48 48c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" }));
});

var getAuthorisationLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 96.003c-26.51 0-48-21.49-48-48C0 21.49 21.49 0 48 0s48 21.49 48 48.003c0 26.51-21.49 48-48 48zm23.02-71.022a3.35 3.35 0 0 0-4.735 0L48 43.269 29.712 24.98a3.35 3.35 0 0 0-4.735 0 3.344 3.344 0 0 0 0 4.734l18.288 18.288-18.288 18.288a3.344 3.344 0 0 0 0 4.735 3.35 3.35 0 0 0 4.735 0L48 52.738l18.285 18.288a3.35 3.35 0 0 0 4.734 0 3.35 3.35 0 0 0 0-4.735L52.735 48.003l18.284-18.288a3.35 3.35 0 0 0 0-4.734z" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CrossSolidCircleLarge = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M48 96.003c-26.51 0-48-21.49-48-48C0 21.49 21.49 0 48 0s48 21.49 48 48.003c0 26.51-21.49 48-48 48zm23.02-71.022a3.35 3.35 0 0 0-4.735 0L48 43.269 29.712 24.98a3.35 3.35 0 0 0-4.735 0 3.344 3.344 0 0 0 0 4.734l18.288 18.288-18.288 18.288a3.344 3.344 0 0 0 0 4.735 3.35 3.35 0 0 0 4.735 0L48 52.738l18.285 18.288a3.35 3.35 0 0 0 4.734 0 3.35 3.35 0 0 0 0-4.735L52.735 48.003l18.284-18.288a3.35 3.35 0 0 0 0-4.734z" }));
});

var getCrossSolidCircleLarge = getThemeIcon(VMIcon$2, CrossSolidCircleLarge);

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M49.92 2C75.37 2 96 22.63 96 48.08S75.37 94.16 49.92 94.16c-20.096-.001-37.874-13.025-43.935-32.186-4.983-15.756-1.098-32.673 9.581-44.614H6.432V9.68h23.04v23.04h-7.68l-.001-10.798C11.105 33.396 8.294 50.565 15.483 65.107c8.397 16.988 27.93 25.312 46 19.603s29.275-23.744 26.389-42.473C84.986 23.508 68.87 9.684 49.92 9.68zm2.004 15.36v31.054H72.96v7.68H51.924a10.664 10.664 0 0 1-10.366 11.602 9.214 9.214 0 0 1-9.205-9.202c0-5.018 3.624-10.08 11.723-10.08h.168V17.36zm-7.68 38.734h-.168c-4.043 0-4.043 1.744-4.043 2.4a1.525 1.525 0 0 0 1.525 1.522c.446 0 2.671-.191 2.686-3.922z" }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("rect", { width: "96", height: "96", rx: "48" }), React.createElement("path", { d: "M51 49h20.08c2.16 0 3.92 1.856 3.92 4 0 2.208-1.72 4-3.92 4H46.92c-1.08 0-2.056-.46-2.772-1.168A3.957 3.957 0 0 1 43 53.016v-32.04c0-2.2 1.856-3.976 4-3.976 2.208 0 4 1.72 4 3.98V49z", fill: "#FFF" }));
});

var getPendingFilledLarge = getThemeIcon(VMIcon$3, GenericIcon$2);

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 95.999c-26.508 0-48-21.486-48-48 0-26.508 21.492-48 48-48s48 21.492 48 48c0 26.514-21.492 48-48 48zm-6.137-24c.078 0 .156 0 .228-.006 1.656-.078 3.162-.906 4.032-2.25l25.116-38.436c1.47-2.244.744-5.19-1.608-6.588-2.346-1.392-5.442-.702-6.9 1.53l-21.264 32.55-8.46-10.644c-1.668-2.106-4.806-2.532-7.02-.93-2.208 1.596-2.64 4.59-.966 6.69l12.846 16.194c.948 1.194 2.436 1.89 3.996 1.89z" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ height: "96", viewBox: "0 0 40 40", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20C39.988 8.96 31.04.012 20 0z" }), React.createElement("g", { fill: "none", fillRule: "evenodd" }, React.createElement("path", { d: "M0 0h40v40H0z" }), React.createElement("path", { d: "M16.711 29.8a1.462 1.462 0 0 1-1.043.473h-.034c-.387 0-.757-.153-1.03-.424l-5.827-5.787 2.06-2.045 4.746 4.714 13.54-14.792 2.154 1.947z", fill: "#fff" })));
});

var getTickOutlineCircleFilledLarge = getThemeIcon(VMIcon$4, GenericIcon$3);

var _templateObject$c = taggedTemplateLiteral(['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n'], ['\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: center;\n\n\t', ';\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\talign-self: stretch;\n\talign-items: ', ';\n\n\t', ';\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject5$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject6$3 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: ', ';\n\talign-items: ', ';\n\tjustify-content: flex-start;\n\twidth: 100%;\n\n\t', ';\n']),
    _templateObject7$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n'], ['\n\tdisplay: flex;\n\twidth: 100%;\n\n\t> div {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\tflex-basis: 33.33%;\n\t}\n\n\t', ';\n']);

var baseProps = {
	nodes: PropTypes.arrayOf(PropTypes.node).isRequired,
	isNonWrapping: PropTypes.bool,
	verticalAlignment: PropTypes.string,
	isNonFlexForPrint: PropTypes.bool,
	breakpointForNonStacked: PropTypes.oneOf(['480', '540', '640', '960', '1280'])
};

var defaultProps = {
	isNonWrapping: false,
	isNonFlexForPrint: false,
	verticalAlignment: 'stretch'
};

var CenteredWrapper = styled('div')(_templateObject$c, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var verticalAlignmentToAlignItems = function verticalAlignmentToAlignItems(verticalAlignment) {
	switch (verticalAlignment) {
		case 'top':
			return 'flex-start';
		case 'bottom':
			return 'flex-end';
		case 'center':
			return 'center';
		case 'baseline':
			return 'baseline';
		case 'stretch':
		default:
			return 'stretch';
	}
};

var Centered = function Centered(_ref) {
	var nodes = _ref.nodes,
	    isNonWrapping = _ref.isNonWrapping,
	    verticalAlignment = _ref.verticalAlignment,
	    breakpointForNonStacked = _ref.breakpointForNonStacked;
	return React.createElement(
		CenteredWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

Centered.propTypes = _extends({}, baseProps);

Centered.defaultProps = _extends({}, defaultProps);

var JustifiedNodeWrapper = styled('div')(_templateObject2$9, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var JustifiedWrapper = styled('div')(_templateObject3$5, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var Justified = function Justified(_ref2) {
	var nodes = _ref2.nodes,
	    isNonWrapping = _ref2.isNonWrapping,
	    verticalAlignment = _ref2.verticalAlignment,
	    breakpointForNonStacked = _ref2.breakpointForNonStacked;
	return React.createElement(
		JustifiedWrapper,
		{ isNonWrapping: isNonWrapping, breakpointForNonStacked: breakpointForNonStacked },
		nodes.map(function (x, index) {
			return React.createElement(
				JustifiedNodeWrapper,
				{
					alignItems: verticalAlignmentToAlignItems(verticalAlignment),
					breakpointForNonStacked: breakpointForNonStacked,
					key: index
				},
				x
			);
		})
	);
};

Justified.propTypes = _extends({}, baseProps);

Justified.defaultProps = _extends({}, defaultProps);

var LeftAlignedWrapper = styled('div')(_templateObject4$4, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var LeftAligned = function LeftAligned(_ref3) {
	var nodes = _ref3.nodes,
	    isNonWrapping = _ref3.isNonWrapping,
	    verticalAlignment = _ref3.verticalAlignment,
	    breakpointForNonStacked = _ref3.breakpointForNonStacked;
	return React.createElement(
		LeftAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

LeftAligned.propTypes = _extends({}, baseProps);

LeftAligned.defaultProps = _extends({}, defaultProps);

var RightAlignedWrapper = styled('div')(_templateObject5$3, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var RightAligned = function RightAligned(_ref4) {
	var nodes = _ref4.nodes,
	    isNonWrapping = _ref4.isNonWrapping,
	    verticalAlignment = _ref4.verticalAlignment,
	    breakpointForNonStacked = _ref4.breakpointForNonStacked;
	return React.createElement(
		RightAlignedWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				'div',
				{ key: index },
				x
			);
		})
	);
};

RightAligned.propTypes = _extends({}, baseProps);

RightAligned.defaultProps = _extends({}, defaultProps);

var ThirdsWrapper = styled('div')(_templateObject6$3, function (props) {
	return props.isNonWrapping ? 'nowrap' : 'wrap';
}, function (props) {
	return props.alignItems;
}, function (props) {
	return props.breakpointForNonStacked && '@media (max-width: ' + props.breakpointForNonStacked + 'px) {\n\t\t\tdisplay: block;\n\t\t}';
});

var NodeWrapper = styled('div')(_templateObject7$2, breakpoints.sm2, function (props) {
	return !props.isNonFlexForPrint && '@media print { flex-basis: 100%; }';
});

var Thirds = function Thirds(_ref5) {
	var nodes = _ref5.nodes,
	    isNonWrapping = _ref5.isNonWrapping,
	    verticalAlignment = _ref5.verticalAlignment,
	    isNonFlexForPrint = _ref5.isNonFlexForPrint,
	    breakpointForNonStacked = _ref5.breakpointForNonStacked;
	return React.createElement(
		ThirdsWrapper,
		{
			alignItems: verticalAlignmentToAlignItems(verticalAlignment),
			isNonWrapping: isNonWrapping,
			isNonFlexForPrint: isNonFlexForPrint,
			breakpointForNonStacked: breakpointForNonStacked
		},
		nodes.map(function (x, index) {
			return React.createElement(
				NodeWrapper,
				{ key: index },
				x
			);
		})
	);
};

Thirds.propTypes = _extends({}, baseProps);

Thirds.defaultProps = _extends({}, defaultProps);

var Inline = {
	Centered: Centered,
	Justified: Justified,
	LeftAligned: LeftAligned,
	RightAligned: RightAligned,
	Thirds: Thirds
};

var main$7 = "LargeBody.js";
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$d = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\tmargin-left: ', ';\n\torder: ', ';\n'], ['\n\tmargin-right: ', ';\n\tmargin-left: ', ';\n\torder: ', ';\n']),
    _templateObject2$a = taggedTemplateLiteral(['\n\t', ';\n\tmargin: 0;\n'], ['\n\t', ';\n\tmargin: 0;\n']),
    _templateObject3$6 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> div > .c-a-icon {\n\t\theight: ', ' !important;\n\t\twidth: ', ' !important;\n\t}\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\t', ';\n\n\t> div > .c-a-icon {\n\t\theight: ', ' !important;\n\t\twidth: ', ' !important;\n\t}\n']);

var StyledIcon = styled('div')(_templateObject$d, function (props) {
	return !props.hasIconAtRight && (props.theme.isCompact ? '8px' : '16px');
}, function (props) {
	return props.hasIconAtRight && (props.theme.isCompact ? '8px' : '16px');
}, function (props) {
	return props.hasIconAtRight ? 1 : 0;
});

var StyledLargeBody = styled('div')(_templateObject2$a, function (props) {
	return props.theme.isCompact ? useFontSize.of.uist() : useFontSize.of.arran();
});

var StyledWrapper$2 = styled('div')(_templateObject3$6, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
}, function (props) {
	return props.theme.isCompact ? '27px' : '32px';
}, function (props) {
	return props.theme.isCompact ? '27px' : '32px';
});

/**
 * @example ./Design.md
 */
var LargeBody = function LargeBody(_ref) {
	var children = _ref.children,
	    icon = _ref.icon,
	    hasIconAtRight = _ref.hasIconAtRight,
	    isFlush = _ref.isFlush,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledWrapper$2,
			{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
			icon && React.createElement(
				StyledIcon,
				{ hasIconAtRight: hasIconAtRight },
				icon
			),
			React.createElement(
				StyledLargeBody,
				null,
				children
			)
		)
	);
};

LargeBody.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Optional icon with LargeBody. */
	icon: PropTypes.node,
	/** Congiruation of icon to be right aligned to LargeBody. */
	hasIconAtRight: PropTypes.bool,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

LargeBody.defaultProps = {
	hasIconAtRight: false,
	isFlush: false,
	'data-test-id': 'largebody'
};

var main$8 = "ProminentLabel.js";
var packageJson$8 = {
	main: main$8,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$e = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledProminentLabel = styled('div')(_templateObject$e, function (props) {
	return props.theme.isCompact ? useFontSize.of.jura() : useFontSize.of.arran();
}, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var ProminentLabel = function ProminentLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$8, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledProminentLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

ProminentLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

ProminentLabel.defaultProps = {
	isFlush: false
};

var main$9 = "StandardLabel.js";
var packageJson$9 = {
	main: main$9,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$f = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledStandardLabel = styled('div')(_templateObject$f, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$9, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush, 'data-test-id': dataTestId, id: id },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String id passed to underlying html element. */
	id: PropTypes.string
};

StandardLabel.defaultProps = {
	isFlush: false,
	'data-test-id': 'standard-label'
};

var _templateObject$g = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tpadding: ', ' ', ';\n\tposition: absolute;\n\tleft: 0;\n\ttop: -20px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tpadding: ', ' ', ';\n\tposition: absolute;\n\tleft: 0;\n\ttop: -20px;\n']),
    _templateObject2$b = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-block;\n\t', ';\n\t', ';\n\tpadding-top: ', ';\n\tpadding-right: ', ';\n\tpadding-bottom: ', ';\n\tpadding-left: ', ';\n\tposition: relative;\n\twidth: 100%;\n\n\t@media (max-width: ', ') {\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-block;\n\t', ';\n\t', ';\n\tpadding-top: ', ';\n\tpadding-right: ', ';\n\tpadding-bottom: ', ';\n\tpadding-left: ', ';\n\tposition: relative;\n\twidth: 100%;\n\n\t@media (max-width: ', ') {\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject3$7 = taggedTemplateLiteral(['\n\t', ';\n\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 26px;\n\t\twidth: 26px;\n\t\tmargin-right: ', ';\n\t}\n\n\th3 {\n\t\tcolor: ', ';\n\t}\n'], ['\n\t', ';\n\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 26px;\n\t\twidth: 26px;\n\t\tmargin-right: ', ';\n\t}\n\n\th3 {\n\t\tcolor: ', ';\n\t}\n']);

var StyledHeaderLozenge = styled('span')(_templateObject$g, function (props) {
	return props.lozengeColour;
}, function (props) {
	return props.theme.borderRadius;
}, spacing.SINGLE, spacing.TRIPLE);

var StyledStandoutTile = styled('div')(_templateObject2$b, function (props) {
	return props.backgroundColour;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.hasLozenge && 'margin-top: 20px;';
}, function (props) {
	return props.hasIcon && 'border-left: 8px solid ' + props.borderColour;
}, function (props) {
	return props.hasLozenge ? '36px' : spacing.TRIPLE;
}, spacing.SINGLE, spacing.SINGLE, spacing.TRIPLE, breakpoints.sm2, spacing.TRIPLE);

var StyledHeaderWrapper = styled('div')(_templateObject3$7, externalMarginRegular, function (props) {
	return props.borderColour;
}, spacing.SINGLE, colours.generalPalette.black);

var BaseInternalStandoutTile = function BaseInternalStandoutTile(_ref) {
	var backgroundColour = _ref.backgroundColour,
	    borderColour = _ref.borderColour,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    hasLozenge = _ref.hasLozenge,
	    hasIcon = _ref.hasIcon,
	    lozengeColour = _ref.lozengeColour,
	    titleText = _ref.titleText,
	    icon = _ref.icon;
	return React.createElement(
		StyledStandoutTile,
		{
			backgroundColour: backgroundColour,
			borderColour: borderColour,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			hasIcon: hasIcon
		},
		hasLozenge && React.createElement(
			LargeBody,
			{ isFlush: true },
			React.createElement(
				StyledHeaderLozenge,
				{ lozengeColour: lozengeColour },
				titleText
			)
		),
		hasIcon && React.createElement(
			StyledHeaderWrapper,
			{ borderColour: borderColour },
			React.createElement(Inline.LeftAligned, { verticalAlignment: 'center', nodes: [icon, React.createElement(
					LargeBody,
					{ isFlush: true },
					titleText
				)] })
		),
		children
	);
};

var baseProps$1 = {
	/** Content of the tile. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Data attribute targeting select for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Shows the lozenge. */
	hasLozenge: PropTypes.bool
};

BaseInternalStandoutTile.propTypes = _extends({}, baseProps$1, {
	/** Sets tile background colour. */
	backgroundColour: PropTypes.string.isRequired,
	/** Sets lozenge background colour. */
	lozengeColour: PropTypes.string,
	/** Sets border-left background colour. */
	borderColour: PropTypes.string,
	/** Sets the title text. */
	titleText: PropTypes.string
});

BaseInternalStandoutTile.defaultProps = {
	'data-test-id': 'standout-tile',
	hasLozenge: false
};

var Important = function Important(_ref2) {
	var children = _ref2.children,
	    dataTestId = _ref2['data-test-id'],
	    hasLozenge = _ref2.hasLozenge,
	    titleText = _ref2.titleText;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.importantLightest,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			lozengeColour: colours.utility.importantLighter,
			titleText: titleText
		},
		children
	);
};

Important.propTypes = _extends({}, baseProps$1);

Important.defaultProps = {
	titleText: 'Important'
};

var Guidance = function Guidance(_ref3) {
	var children = _ref3.children,
	    dataTestId = _ref3['data-test-id'],
	    hasLozenge = _ref3.hasLozenge,
	    titleText = _ref3.titleText;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.guidanceLightest,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			lozengeColour: colours.utility.guidanceLighter,
			titleText: titleText
		},
		children
	);
};

Guidance.propTypes = _extends({}, baseProps$1);

Guidance.defaultProps = {
	titleText: 'Guidance'
};

var Remember = function Remember(_ref4) {
	var children = _ref4.children,
	    dataTestId = _ref4['data-test-id'],
	    hasLozenge = _ref4.hasLozenge,
	    titleText = _ref4.titleText;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.rememberLightest,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			lozengeColour: colours.utility.rememberLighter,
			titleText: titleText
		},
		children
	);
};

Remember.propTypes = _extends({}, baseProps$1);

Remember.defaultProps = {
	titleText: 'Remember'
};

var Tip = function Tip(_ref5) {
	var children = _ref5.children,
	    dataTestId = _ref5['data-test-id'],
	    hasLozenge = _ref5.hasLozenge,
	    titleText = _ref5.titleText;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.tipLightest,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			lozengeColour: colours.utility.tipLighter,
			titleText: titleText
		},
		children
	);
};

Tip.propTypes = _extends({}, baseProps$1);

Tip.defaultProps = {
	titleText: 'Tip'
};

var Authorise = function Authorise(_ref6) {
	var children = _ref6.children,
	    dataTestId = _ref6['data-test-id'],
	    hasLozenge = _ref6.hasLozenge,
	    titleText = _ref6.titleText,
	    icon = _ref6.icon,
	    hasIcon = _ref6.hasIcon;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.guidanceLightest,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			borderColour: colours.utility.guidance,
			titleText: titleText,
			tileType: 'authorise',
			hasIcon: hasIcon,
			icon: icon
		},
		children
	);
};

Authorise.propTypes = _extends({}, baseProps$1);

Authorise.defaultProps = {
	titleText: 'Authorise'
};

var Error$1 = function Error(_ref7) {
	var children = _ref7.children,
	    dataTestId = _ref7['data-test-id'],
	    hasLozenge = _ref7.hasLozenge,
	    titleText = _ref7.titleText,
	    icon = _ref7.icon,
	    hasIcon = _ref7.hasIcon;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.errorLightestUpdated,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			borderColour: colours.utility.errorUpdated,
			titleText: titleText,
			tileType: 'error',
			hasIcon: hasIcon,
			icon: icon
		},
		children
	);
};

Error$1.propTypes = _extends({}, baseProps$1);

Error$1.defaultProps = {
	titleText: 'Error'
};

var Pending = function Pending(_ref8) {
	var children = _ref8.children,
	    dataTestId = _ref8['data-test-id'],
	    hasLozenge = _ref8.hasLozenge,
	    titleText = _ref8.titleText,
	    icon = _ref8.icon,
	    hasIcon = _ref8.hasIcon;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.informationLightestUpdated,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			borderColour: colours.utility.informationUpdated,
			titleText: titleText,
			tileType: 'pending',
			hasIcon: hasIcon,
			icon: icon
		},
		children
	);
};

Pending.propTypes = _extends({}, baseProps$1);

Pending.defaultProps = {
	titleText: 'Pending'
};

var Success = function Success(_ref9) {
	var children = _ref9.children,
	    dataTestId = _ref9['data-test-id'],
	    hasLozenge = _ref9.hasLozenge,
	    titleText = _ref9.titleText,
	    icon = _ref9.icon,
	    hasIcon = _ref9.hasIcon;
	return React.createElement(
		BaseInternalStandoutTile,
		{
			backgroundColour: colours.utility.successLightestUpdated,
			'data-test-id': dataTestId,
			hasLozenge: hasLozenge,
			borderColour: colours.utility.successUpdated,
			titleText: titleText,
			tileType: 'success',
			hasIcon: hasIcon,
			icon: icon
		},
		children
	);
};

Success.propTypes = _extends({}, baseProps$1);

Success.defaultProps = {
	titleText: 'Success'
};

var InternalStandoutTile = {
	Important: Important,
	Guidance: Guidance,
	Remember: Remember,
	Tip: Tip,
	Authorise: Authorise,
	Error: Error$1,
	Pending: Pending,
	Success: Success
};

var main$a = "StandoutTile.js";
var variants = ["Important", "Guidance", "Remember", "Tip", "Authorise", "Error", "Pending", "Success"];
var packageJson$a = {
	main: main$a,
	variants: variants,
	"component-id": 1048,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var getTileIcon = function getTileIcon(tileType, theme) {
	var TickOutlineCircleFilledLargeIcon = getTickOutlineCircleFilledLarge(theme.name);
	var CrossSolidCircleLargeIcon = getCrossSolidCircleLarge(theme.name);
	var AuthorisationLargeIcon = getAuthorisationLarge(theme.name);
	var PendingFilledLargeIcon = getPendingFilledLarge(theme.name);

	switch (tileType) {
		case 'authorise':
			return React.createElement(AuthorisationLargeIcon, null);
		case 'error':
			return React.createElement(CrossSolidCircleLargeIcon, null);
		case 'pending':
			return React.createElement(PendingFilledLargeIcon, null);
		case 'success':
			return React.createElement(TickOutlineCircleFilledLargeIcon, null);
	}
};

var baseProps$2 = {
	/** Content of the tile. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Data attribute targeting select for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** Sets the title text. */
	titleText: PropTypes.string
};

var baseDefaultProps = {
	'data-test-id': 'standout-tile'
};

var UnwrappedImportant = function UnwrappedImportant(_ref) {
	var children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    titleText = _ref.titleText;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Important', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Important,
			{ 'data-test-id': dataTestId, titleText: titleText, hasLozenge: true },
			children
		)
	);
};

UnwrappedImportant.propTypes = _extends({}, baseProps$2);

UnwrappedImportant.defaultProps = _extends({}, baseDefaultProps);

var Important$1 = withTheme(UnwrappedImportant);

var UnwrappedGuidance = function UnwrappedGuidance(_ref2) {
	var children = _ref2.children,
	    dataTestId = _ref2['data-test-id'],
	    titleText = _ref2.titleText;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Guidance', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Guidance,
			{ 'data-test-id': dataTestId, titleText: titleText, hasLozenge: true },
			children
		)
	);
};

UnwrappedGuidance.propTypes = _extends({}, baseProps$2);

UnwrappedGuidance.defaultProps = _extends({}, baseDefaultProps);

var Guidance$1 = withTheme(UnwrappedGuidance);

var UnwrappedRemember = function UnwrappedRemember(_ref3) {
	var children = _ref3.children,
	    dataTestId = _ref3['data-test-id'],
	    titleText = _ref3.titleText;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Remember', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Remember,
			{ 'data-test-id': dataTestId, titleText: titleText, hasLozenge: true },
			children
		)
	);
};

UnwrappedRemember.propTypes = _extends({}, baseProps$2);

UnwrappedRemember.defaultProps = _extends({}, baseDefaultProps);

var Remember$1 = withTheme(UnwrappedRemember);

var UnwrappedTip = function UnwrappedTip(_ref4) {
	var children = _ref4.children,
	    dataTestId = _ref4['data-test-id'],
	    titleText = _ref4.titleText;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Tip', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Tip,
			{ 'data-test-id': dataTestId, titleText: titleText, hasLozenge: true },
			children
		)
	);
};

UnwrappedTip.propTypes = _extends({}, baseProps$2);

UnwrappedTip.defaultProps = _extends({}, baseDefaultProps);

var Tip$1 = withTheme(UnwrappedTip);

var UnwrappedAuthorise = function UnwrappedAuthorise(_ref5) {
	var children = _ref5.children,
	    dataTestId = _ref5['data-test-id'],
	    titleText = _ref5.titleText,
	    theme = _ref5.theme;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Authorise', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Authorise,
			{
				'data-test-id': dataTestId,
				titleText: titleText,
				icon: getTileIcon('authorise', theme),
				hasIcon: true
			},
			children
		)
	);
};

UnwrappedAuthorise.propTypes = _extends({}, baseProps$2);

UnwrappedAuthorise.defaultProps = _extends({}, baseDefaultProps);

var Authorise$1 = withTheme(UnwrappedAuthorise);

var UnwrappedError = function UnwrappedError(_ref6) {
	var children = _ref6.children,
	    dataTestId = _ref6['data-test-id'],
	    titleText = _ref6.titleText,
	    theme = _ref6.theme;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Error', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Error,
			{
				'data-test-id': dataTestId,
				titleText: titleText,
				icon: getTileIcon('error', theme),
				hasIcon: true
			},
			children
		)
	);
};

UnwrappedError.propTypes = _extends({}, baseProps$2);

UnwrappedError.defaultProps = _extends({}, baseDefaultProps);

var Error$2 = withTheme(UnwrappedError);

var UnwrappedPending = function UnwrappedPending(_ref7) {
	var children = _ref7.children,
	    dataTestId = _ref7['data-test-id'],
	    titleText = _ref7.titleText,
	    theme = _ref7.theme;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Pending', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Pending,
			{
				'data-test-id': dataTestId,
				titleText: titleText,
				icon: getTileIcon('pending', theme),
				hasIcon: true
			},
			children
		)
	);
};

UnwrappedPending.propTypes = _extends({}, baseProps$2);

UnwrappedPending.defaultProps = _extends({}, baseDefaultProps);

var Pending$1 = withTheme(UnwrappedPending);

var UnwrappedSuccess = function UnwrappedSuccess(_ref8) {
	var children = _ref8.children,
	    dataTestId = _ref8['data-test-id'],
	    titleText = _ref8.titleText,
	    theme = _ref8.theme;
	return React.createElement(
		InternalComponentFrame,
		{ variant: 'Success', packageJson: packageJson$a },
		React.createElement(
			InternalStandoutTile.Success,
			{
				'data-test-id': dataTestId,
				titleText: titleText,
				icon: getTileIcon('success', theme),
				hasIcon: true
			},
			children
		)
	);
};

UnwrappedSuccess.propTypes = _extends({}, baseProps$2);

UnwrappedSuccess.defaultProps = _extends({}, baseDefaultProps);

var Success$1 = withTheme(UnwrappedSuccess);

/**
 * @example ./Design.md
 */

var StandoutTile = {
	Important: Important$1,
	Guidance: Guidance$1,
	Remember: Remember$1,
	Tip: Tip$1,
	Authorise: Authorise$1,
	Error: Error$2,
	Pending: Pending$1,
	Success: Success$1
};

var main$b = "NavigationButton.js";
var variants$1 = ["Back", "Cancel", "Confirm", "Continue", "Next", "Primary", "Secondary", "Submit", "Tertiary"];
var deprecations$5 = [{
	variants: ["Confirm", "Continue", "Next", "Submit"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Primary"
	}
}, {
	variants: ["Back"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Secondary"
	}
}, {
	variants: ["Cancel"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Tertiary"
	}
}];
var packageJson$b = {
	main: main$b,
	variants: variants$1,
	"component-id": 812,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: deprecations$5
};

var getLabelText = function getLabelText(label, labelText) {
	if (label === undefined) {
		return labelText;
	}

	DeprecationWarnings.logProp(packageJson$b, 'label prop deprecated in favour of labelText prop.');
	return label;
};

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 96H56c-.238 0-.475-.02-.709-.062a31.449 31.449 0 0 1-2.518-.56A17.923 17.923 0 0 1 48 93.325a18.772 18.772 0 0 1-7.377 2.63c-.168.019-.453.046-.623.046H12a4 4 0 0 1-4-4V44a8.21 8.21 0 0 1 8-8h8V24C24 10.745 34.745 0 48 0s24 10.745 24 24v8h-8v-8c0-8.837-7.163-16-16-16s-16 7.163-16 16v16a3.999 3.999 0 0 1-4 4H16v44h23.74a10.522 10.522 0 0 0 2.153-.55 21.577 21.577 0 0 1-.825-1.317L34.23 74.246a15.892 15.892 0 0 1 13.846-23.754h.002a15.866 15.866 0 0 1 13.793 23.781l-6.91 11.899c-.252.437-.52.86-.8 1.273.216.075.435.141.655.2.504.132 1.022.254 1.555.355H80V44H36v-8h44a8.21 8.21 0 0 1 8 8v48a4 4 0 0 1-4 4zM48.074 58.492a7.937 7.937 0 0 0-6.135 2.89 7.824 7.824 0 0 0-.775 8.872l6.838 11.886.025.043.016-.027 6.908-11.898a7.825 7.825 0 0 0-.736-8.875 7.95 7.95 0 0 0-6.14-2.891z" }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.932 9c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H2.96c-.61 0-1.105-.448-1.105-1V8c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM4.065 4.5c0-1.933 1.732-3.5 3.867-3.5C10.068 1 11.8 2.567 11.8 4.5V6H4.065V4.5zm8.84 1.5V4.5c0-2.485-2.226-4.5-4.973-4.5C5.186 0 2.96 2.015 2.96 4.5V6C1.74 6 .75 6.895.75 8v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2V8c0-1.105-.99-2-2.21-2z" }));
});

var getLockOutlineLarge = getThemeIcon(VMIcon$5, GenericIcon$4);

var _templateObject$h = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n'], ['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$c = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n']);

var StyledIconWrapper = styled$1('div')(_templateObject$h, spacing.SINGLE, function (props) {
	return props.iconColour;
});

var StyledWrapper$3 = styled$1('div')(_templateObject2$c, colours.component.background, function (props) {
	return props.borderColour;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, spacing.DOUBLE, spacing.TRIPLE, function (props) {
	return props.isVisible ? spacing.DOUBLE : '-75vw';
}, spacing.DOUBLE);

var BaseToast = function BaseToast(_ref) {
	var borderColour = _ref.borderColour,
	    icon = _ref.icon,
	    iconColour = _ref.iconColour,
	    isVisible = _ref.isVisible,
	    messageText = _ref.messageText;
	return React.createElement(
		StyledWrapper$3,
		{ borderColour: borderColour, isVisible: isVisible },
		icon && React.createElement(
			StyledIconWrapper,
			{ iconColour: iconColour },
			icon
		),
		React.createElement(
			ProminentLabel,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				messageText
			)
		)
	);
};

BaseToast.propTypes = {
	/** Border colour. */
	borderColour: PropTypes.string,
	/** Icon shown to the left of the message text. */
	icon: PropTypes.node,
	/** Icon fill colour. */
	iconColour: PropTypes.string,
	/** Character count as number. */
	isVisible: PropTypes.bool.isRequired,
	/** Message text. */
	messageText: PropTypes.string.isRequired
};

BaseToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var InternalLockedToast = function InternalLockedToast(_ref) {
	var isVisible = _ref.isVisible,
	    theme = _ref.theme;

	var PadlockIcon = getLockOutlineLarge(theme.name);

	return React.createElement(BaseToast, {
		borderColour: colours.component.locked,
		icon: React.createElement(PadlockIcon, null),
		iconColour: colours.component.locked,
		isVisible: isVisible,
		messageText: 'Feature is locked.'
	});
};

InternalLockedToast.propTypes = {
	/** Makes the toast visible. */
	isVisible: PropTypes.bool.isRequired
};

InternalLockedToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var WrappedInternalLockedToast = withTheme(InternalLockedToast);

var _templateObject$i = taggedTemplateLiteral(['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n'], ['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n']),
    _templateObject2$d = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject3$8 = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n'], ['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n']);

var getPrimaryHoverStyles = function getPrimaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n\t\t\tbackground-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tborder-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t}';
	}
	return '';
};

var getPrimaryBackgroundColour = function getPrimaryBackgroundColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var primaryStyles = function primaryStyles(props) {
	return '\n\tbackground-color: ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder-bottom-color: ' + (props.isLoading ? props.theme.colours.disabledNavigationButton + ' ' + INTERNET_BANKING_CSS_OVERRIDE : !props.isLocked && props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE) + ';\n\tcolor: ' + colours.generalPalette.white + ';\n\t' + getPrimaryHoverStyles(props) + '\n';
};

var getSecondaryHoverStyles = function getSecondaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            background-color: ' + props.theme.colours.primary + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n            color: ' + colours.generalPalette.white + ';\n\t\t}';
	}
	return '';
};

var getSecondaryBackgroundColour = function getSecondaryBackgroundColour(props) {
	var colour = colours.generalPalette.white;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryBorderColour = function getSecondaryBorderColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryColour = function getSecondaryColour(_ref) {
	var isLocked = _ref.isLocked,
	    isLoading = _ref.isLoading,
	    theme = _ref.theme;

	if (isLocked || isLoading) {
		return colours.generalPalette.white;
	}
	return theme.colours.primary;
};

var secondaryStyles = function secondaryStyles(props) {
	return '\n\tbackground-color: ' + getSecondaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getSecondaryBorderColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tcolor: ' + getSecondaryColour(props) + ';\n\t' + getSecondaryHoverStyles(props) + '\n';
};

var getTertiaryHoverStyles = function getTertiaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            color: ' + props.theme.colours.secondaryAccent + ';\n\t\t}';
	}
	return '';
};

var getTertiaryColour = function getTertiaryColour(_ref2) {
	var isLocked = _ref2.isLocked,
	    isMonotone = _ref2.isMonotone,
	    theme = _ref2.theme;

	if (isLocked) {
		return colours.component.locked;
	}
	return isMonotone ? colours.generalPalette.black : theme.colours.primary;
};

var tertiaryStyles = function tertiaryStyles(props) {
	return '\n\tbackground: none ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tborder: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tcolor: ' + getTertiaryColour(props) + ';\n\tpadding: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\ttext-decoration: underline;\n\theight: ' + (props.theme.isCompact ? 'auto' : '48px') + ';\n\n\t> div > div {\n\t\tfont-family: ' + props.theme.fonts.text.regular + ';\n\t}\n\n\t' + getTertiaryHoverStyles(props) + '\n';
};

var StyledLoadingIcon = styled('div')(_templateObject$i, function (props) {
	return props.isLoading && 'animation: spin 0.75s linear infinite;';
}, function (props) {
	return props.displayType === 'primary' || props.isLoading ? colours.generalPalette.white : props.theme.colours.primary;
}, spacing.SINGLE);

var StyledPadlockIcon = styled('div')(_templateObject2$d, spacing.HALF, function (props) {
	return props.displayType !== 'tertiary' ? colours.generalPalette.white : colours.component.locked;
});

var StyledButton$2 = styled('button')(_templateObject3$8, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return !props.isInline && '\n\t\t\tmargin-bottom: ' + (props.theme.isCompact ? spacing.SINGLE : spacing.DOUBLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tmargin-right: ' + (props.theme.isCompact ? spacing.ONE_AND_HALF : spacing.TRIPLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t';
}, function (props) {
	return props.theme.isCompact ? spacing.QUARTER + ' ' + spacing.SINGLE : spacing.SINGLE + ' ' + spacing.TRIPLE;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.displayType === 'primary' && primaryStyles(props);
}, function (props) {
	return props.displayType === 'secondary' && secondaryStyles(props);
}, function (props) {
	return props.displayType === 'tertiary' && tertiaryStyles(props);
}, function (props) {
	return props.hasFluidHeight && 'height: auto';
});

// eslint-disable-next-line react/prop-types

var UnwrappedNavigationButtonBase = function (_Component) {
	inherits(UnwrappedNavigationButtonBase, _Component);

	function UnwrappedNavigationButtonBase(props) {
		classCallCheck(this, UnwrappedNavigationButtonBase);

		var _this = possibleConstructorReturn(this, (UnwrappedNavigationButtonBase.__proto__ || Object.getPrototypeOf(UnwrappedNavigationButtonBase)).call(this, props));

		_this.state = {
			isVisible: false
		};
		return _this;
	}

	createClass(UnwrappedNavigationButtonBase, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    dataTestId = _props['data-test-id'],
			    display = _props.display,
			    hasFluidHeight = _props.hasFluidHeight,
			    isInline = _props.isInline,
			    isLoading = _props.isLoading,
			    isLocked = _props.isLocked,
			    isMonotone = _props.isMonotone,
			    labelText = _props.labelText,
			    loadingText = _props.loadingText,
			    onClick = _props.onClick,
			    theme = _props.theme,
			    willSubmitForm = _props.willSubmitForm,
			    ariaLabelledBy = _props['aria-labelledby'],
			    ariaLabel = _props['aria-label'];
			var isVisible = this.state.isVisible;

			var PadlockIcon = getLockOutlineLarge(theme.name);
			var threeSeconds = 3000;

			var popToast = function popToast() {
				_this2.setState(function () {
					return { isVisible: true };
				});

				// Load data / make the call. Spoofed here for demo purposes.
				setTimeout(function () {
					_this2.setState(function () {
						return { isVisible: false };
					});
				}, threeSeconds);
			};

			return React.createElement(
				'div',
				null,
				React.createElement(
					StyledButton$2,
					{
						'data-test-id': dataTestId,
						disabled: isLoading,
						displayType: display,
						hasFluidHeight: hasFluidHeight,
						isInline: isInline,
						isLoading: isLoading,
						isLocked: isLocked,
						isMonotone: isMonotone,
						loadingText: true,
						onClick: isLocked ? popToast : onClick,
						type: willSubmitForm ? 'submit' : 'button',
						'aria-labelledby': ariaLabelledBy,
						'aria-label': ariaLabel
					},
					isLoading && React.createElement(
						StyledLoadingIcon,
						{ isLoading: isLoading },
						React.createElement(LoadingOutlineSmallIcon, null)
					),
					React.createElement(
						StandardLabel,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							isLoading ? loadingText : labelText
						)
					),
					isLocked && React.createElement(
						StyledPadlockIcon,
						{ displayType: display, isLocked: isLocked },
						React.createElement(PadlockIcon, null)
					)
				),
				React.createElement(WrappedInternalLockedToast, { isVisible: isVisible })
			);
		}
	}]);
	return UnwrappedNavigationButtonBase;
}(Component);

UnwrappedNavigationButtonBase.propTypes = _extends({}, baseProps$3);

var NavigationButtonBase = withTheme(UnwrappedNavigationButtonBase);

var baseProps$3 = {
	/** Data attribute available for automated test targeting. */
	'data-test-id': PropTypes.string,
	/** Locks the component with associated toast message on click. For Advisor system use only. */
	isLocked: PropTypes.bool,
	/** Button text. */
	labelText: PropTypes.string.isRequired,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Aria-labelledby */
	'aria-labelledby': PropTypes.string,
	/** Aria-label */
	'aria-label': PropTypes.string
};

NavigationButtonBase.propTypes = _extends({}, baseProps$3, {
	/** Sets the display type, controls the styling. */
	display: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
	/** Boolean to override the static button height. */
	hasFluidHeight: PropTypes.bool,
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** When set, will change button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

NavigationButtonBase.defaultProps = {
	hasFluidHeight: false,
	isInline: false,
	isLoading: false,
	isLocked: false,
	isMonotone: false,
	loadingText: 'Loading',
	willSubmitForm: false
};

var primaryVariantProps = _extends({}, baseProps$3, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** Changes button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

var Primary = function Primary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$b, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'primary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Primary.propTypes = _extends({}, primaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Primary.defaultProps = {
	'data-test-id': 'navigation-button-primary',
	variant: 'Primary'
};

var secondaryVariantProps = _extends({}, baseProps$3, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string
});

var Secondary = function Secondary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$b, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'secondary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Secondary.propTypes = _extends({}, secondaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Secondary.defaultProps = {
	'data-test-id': 'navigation-button-secondary',
	variant: 'Secondary'
};

var tertiaryVariantProps = _extends({}, baseProps$3, {
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool
});

var Tertiary = function Tertiary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isInline = _ref.isInline,
	    isLocked = _ref.isLocked,
	    isMonotone = _ref.isMonotone,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson$b, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'tertiary',
			hasFluidHeight: true,
			isInline: isInline,
			isLocked: isLocked,
			isMonotone: isMonotone,
			labelText: finalLabelText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Tertiary.propTypes = _extends({}, tertiaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string
});

Tertiary.defaultProps = {
	'data-test-id': 'navigation-button-tertiary',
	variant: 'Tertiary'
};

var Back = function Back(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    labelText = _ref.labelText,
	    loadingText = _ref.loadingText,
	    onClick = _ref.onClick,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];
	return React.createElement(NavigationButton.Secondary, {
		variant: 'Back',
		'data-test-id': dataTestId,
		display: 'secondary',
		isLoading: isLoading,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		'aria-label': ariaLabel,
		'aria-labelledby': ariaLabelledBy
	});
};

Back.propTypes = _extends({}, secondaryVariantProps);

Back.defaultProps = {
	'data-test-id': 'navigation-button-back',
	labelText: 'Back',
	variant: 'Back'
};

var Cancel = function Cancel(_ref2) {
	var dataTestId = _ref2['data-test-id'],
	    labelText = _ref2.labelText,
	    onClick = _ref2.onClick,
	    ariaLabelledBy = _ref2['aria-labelledby'],
	    ariaLabel = _ref2['aria-label'];
	return React.createElement(NavigationButton.Tertiary, {
		variant: 'Cancel',
		'data-test-id': dataTestId,
		display: 'tertiary',
		labelText: labelText,
		onClick: onClick,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Cancel.propTypes = _extends({}, tertiaryVariantProps);

Cancel.defaultProps = {
	'data-test-id': 'navigation-button-cancel',
	labelText: 'Cancel',
	variant: 'Cancel'
};

var Confirm = function Confirm(_ref3) {
	var dataTestId = _ref3['data-test-id'],
	    isLoading = _ref3.isLoading,
	    isLocked = _ref3.isLocked,
	    labelText = _ref3.labelText,
	    loadingText = _ref3.loadingText,
	    onClick = _ref3.onClick,
	    willSubmitForm = _ref3.willSubmitForm,
	    ariaLabelledBy = _ref3['aria-labelledby'],
	    ariaLabel = _ref3['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Confirm',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Confirm.propTypes = _extends({}, primaryVariantProps);

Confirm.defaultProps = {
	'data-test-id': 'navigation-button-confirm',
	labelText: 'Confirm',
	variant: 'Confirm'
};

var Continue = function Continue(_ref4) {
	var dataTestId = _ref4['data-test-id'],
	    isLoading = _ref4.isLoading,
	    isLocked = _ref4.isLocked,
	    labelText = _ref4.labelText,
	    loadingText = _ref4.loadingText,
	    onClick = _ref4.onClick,
	    willSubmitForm = _ref4.willSubmitForm,
	    ariaLabelledBy = _ref4['aria-labelledby'],
	    ariaLabel = _ref4['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Continue',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Continue.propTypes = _extends({}, primaryVariantProps);

Continue.defaultProps = {
	'data-test-id': 'navigation-button-continue',
	labelText: 'Continue',
	variant: 'Continue'
};

var Next = function Next(_ref5) {
	var dataTestId = _ref5['data-test-id'],
	    isLoading = _ref5.isLoading,
	    isLocked = _ref5.isLocked,
	    labelText = _ref5.labelText,
	    loadingText = _ref5.loadingText,
	    onClick = _ref5.onClick,
	    willSubmitForm = _ref5.willSubmitForm,
	    ariaLabelledBy = _ref5['aria-labelledby'],
	    ariaLabel = _ref5['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Next',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Next.propTypes = _extends({}, primaryVariantProps);

Next.defaultProps = {
	'data-test-id': 'navigation-button-next',
	labelText: 'Next',
	variant: 'Next'
};

var Submit = function Submit(_ref6) {
	var dataTestId = _ref6['data-test-id'],
	    isLoading = _ref6.isLoading,
	    isLocked = _ref6.isLocked,
	    labelText = _ref6.labelText,
	    loadingText = _ref6.loadingText,
	    onClick = _ref6.onClick,
	    willSubmitForm = _ref6.willSubmitForm,
	    ariaLabelledBy = _ref6['aria-labelledby'],
	    ariaLabel = _ref6['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Submit',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Submit.propTypes = _extends({}, primaryVariantProps);

Submit.defaultProps = {
	'data-test-id': 'navigation-button-submit',
	labelText: 'Submit',
	variant: 'Submit'
};

var NavigationButton = {
	Back: Back,
	Cancel: Cancel,
	Confirm: Confirm,
	Continue: Continue,
	Next: Next,
	Primary: Primary,
	Secondary: Secondary,
	Submit: Submit,
	Tertiary: Tertiary
};

var main$c = "NavigationButtonGroup.js";
var packageJson$c = {
	main: main$c,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$j = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: ', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: ', ';\n']),
    _templateObject2$e = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-basis: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-basis: 100%;\n']);

var StyledWrapper$4 = styled('div')(_templateObject$j, spacing.DOUBLE);

var StyledTertiaryButtons = styled('div')(_templateObject2$e);

var NavigationButtonGroup = function NavigationButtonGroup(_ref) {
	var primaryButton = _ref.primaryButton,
	    secondaryButtons = _ref.secondaryButtons,
	    tertiaryButtons = _ref.tertiaryButtons;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$c, hasCustomMargins: true, layout: 'container' },
		React.createElement(
			StyledWrapper$4,
			null,
			secondaryButtons,
			primaryButton,
			tertiaryButtons && React.createElement(
				StyledTertiaryButtons,
				null,
				tertiaryButtons
			)
		)
	);
};

NavigationButtonGroup.propTypes = {
	/** Primary button as single component. */
	primaryButton: PropTypes.node.isRequired,
	/** Secondary button as a single component or an array of multple buttons.
  * When passed as an array provide a key for each component.
  */
	secondaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
	/** Tertiary button as a single component or an array of multple buttons.
  * When passed as an array provide a key for each component.
  */
	tertiaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};

NavigationButtonGroup.defaultProps = {};

var main$d = "UnfinishedWorkModal.js";
var packageJson$d = {
	main: main$d,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$k = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n'], ['\n\tmargin-bottom: ', ';\n']);

var StyledTileWrapper = styled('div')(_templateObject$k, spacing.DOUBLE);

var UnfinishedWorkModal = function UnfinishedWorkModal(_ref) {
	var children = _ref.children,
	    destructiveActionButtonText = _ref.destructiveActionButtonText,
	    isOpen = _ref.isOpen,
	    onClose = _ref.onClose,
	    onDestructiveAction = _ref.onDestructiveAction,
	    safeActionButtonText = _ref.safeActionButtonText,
	    title = _ref.title,
	    titleText = _ref.titleText,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;

	var buttonGroup = React.createElement(NavigationButtonGroup, {
		primaryButton: React.createElement(NavigationButton.Primary, { labelText: safeActionButtonText, onClick: onClose }),
		secondaryButtons: React.createElement(NavigationButton.Secondary, { labelText: destructiveActionButtonText, onClick: onDestructiveAction })
	});

	if (title !== undefined) {
		DeprecationWarnings.logProp(packageJson$d, 'title prop deprecated in favour of titleText prop.');
	}

	return React.createElement(
		BaseModal,
		{
			isOpen: isOpen,
			onClose: onClose,
			titleText: titleText || title,
			footerContent: buttonGroup,
			'data-test-id': dataTestId,
			id: id
		},
		React.createElement(
			StyledTileWrapper,
			null,
			React.createElement(
				StandoutTile.Important,
				null,
				children
			)
		)
	);
};

UnfinishedWorkModal.propTypes = {
	/** Body content. */
	children: PropTypes.node.isRequired,
	/** Destructive action button text. */
	destructiveActionButtonText: PropTypes.string.isRequired,
	/** Set to true to show the modal. */
	isOpen: PropTypes.bool,
	/** Callback function invoked when component is clicked. */
	onClose: PropTypes.func.isRequired,
	/** Callback function invoked on destructive action. */
	onDestructiveAction: PropTypes.func.isRequired,
	/** Safe action button text. */
	safeActionButtonText: PropTypes.string.isRequired,
	/** DEPRECATED: Use titleText prop. */
	title: PropTypes.string,
	/** Title text. */
	titleText: PropTypes.string.isRequired,
	/** Partial Data attribute targeting modal for automation test purposes - appended by -button and -container. */
	'data-test-id': PropTypes.string,
	/** A unique ID used for identification within the DOM.. */
	id: PropTypes.string
};

UnfinishedWorkModal.defaultProps = {
	isOpen: false,
	'data-test-id': 'confirmation-modal',
	id: 'confirmation-modal'
};

export { CentredModal, ConfirmationModal, WrappedLoader as Loader, Modal, UnfinishedWorkModal };
